/* ============================================================
   DIY 手串设计器 - 交互逻辑 (Dawn 主题)
   依赖 sections/diy-bracelet.liquid 注入的 #diy-bracelet-config

   功能：
   1. 意图选择（Intention）—— 营销卖点，显示预览角标 + 订单属性
   2. 从后台两个 Collection 拉取珠子库 / 吊坠库（每个商品 = 一种珠子/吊坠）
   3. 点选珠子/吊坠，实时用 SVG 渲染手串预览（环形串珠 + 吊坠 + 刻字）
   4. 手腕尺寸选择
   5. 保存设计（localStorage）/ 分享设计（URL 参数，打开即可恢复）
   6. 加购：底座 + 每颗珠子 + 每个吊坠作为独立 line items 提交，
      同一串用分组编号标记，意图/尺寸/刻字作为属性 —— 价格精确、无需 App。
   ============================================================ */

(function () {
  'use strict';

  var section = document.getElementById('diy-bracelet');
  var configEl = document.getElementById('diy-bracelet-config');
  if (!section || !configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    console.error('DIY bracelet: config parse failed', e);
    return;
  }

  // ---------- DOM ----------
  var beadsBox = document.getElementById('diy-bracelet-beads');
  var charmsBox = document.getElementById('diy-bracelet-charms');
  var accessoriesBox = document.getElementById('diy-bracelet-accessories');
  // 复核抽屉 + 准备弹窗
  var reviewEl = document.getElementById('diy-review');
  var reviewBody = document.getElementById('diy-review-body');
  var prepEl = document.getElementById('diy-prep');
  var prepMsgEl = document.getElementById('diy-prep-msg');
  var prepActionsEl = document.getElementById('diy-prep-actions');
  var styleFiltersBox = document.getElementById('diy-bracelet-style-filters');
  var accessoryCountEl = document.getElementById('diy-bracelet-accessory-count');
  var intentionsBox = document.getElementById('diy-bracelet-intentions');
  var sizesBox = document.getElementById('diy-bracelet-sizes');
  var previewBox = document.getElementById('diy-bracelet-preview');
  var badgeEl = document.getElementById('diy-bracelet-badge');
  var beadCountEl = document.getElementById('diy-bracelet-bead-count');
  var charmCountEl = document.getElementById('diy-bracelet-charm-count');
  var engraveInput = document.getElementById('diy-bracelet-engrave');
  var summaryEl = document.getElementById('diy-bracelet-summary');
  var totalEl = document.getElementById('diy-bracelet-total');
  var addBtn = document.getElementById('diy-bracelet-add');
  var statusEl = document.getElementById('diy-bracelet-status');
  var saveBtn = document.getElementById('diy-bracelet-save');
  var shareBtn = document.getElementById('diy-bracelet-share');
  var publishBtn = document.getElementById('diy-bracelet-publish');
  var publishModal = document.getElementById('diy-publish-modal');
  var pubName = document.getElementById('diy-pub-name');
  var pubIntention = document.getElementById('diy-pub-intention');
  var pubCreator = document.getElementById('diy-pub-creator');
  var pubPaypal = document.getElementById('diy-pub-paypal');
  var pubStory = document.getElementById('diy-pub-story');
  var pubEmail = document.getElementById('diy-pub-email');
  var pubCancel = document.getElementById('diy-pub-cancel');
  var pubConfirm = document.getElementById('diy-pub-confirm');
  var pubStatus = document.getElementById('diy-pub-status');


  // ---------- 状态 ----------
  // beads/charms: [{ id, variantId, title, price, image }]，同一种可出现多次
  var state = {
    beads: [],
    charms: [],
    engraving: '',
    intention: null,   // config.intentions 中的对象
    intentionIdx: -1,
    size: null,        // 字符串，如 "6.5"
    sizeIdx: -1,
    sizeMm: '8',       // 珠子毫米筛选默认 8mm（只作用于水晶珠）
    style: '',         // 配饰款式筛选，'' = 全部（只作用于配饰）
    history: [],
    future: [],
    enterIdx: -1,
    enterCharmIdx: -1,
    flyFrom: null,
    selectedBeadIdx: -1,
    replaceMode: false
  };

  var STONE_MEANING = {
    'rose-quartz': 'Love', 'strawberry-quartz': 'Joy', 'amethyst': 'Calm',
    'clear-quartz': 'Clarity', 'black-tourmaline': 'Protection', 'tiger-eye': 'Courage',
    'citrine': 'Abundance', 'carnelian': 'Energy', 'green-aventurine': 'Luck',
    'natural-agate': 'Balance', 'rutilated-quartz': 'Focus', 'gold-rutile': 'Wealth',
    'gold-rutile-quartz': 'Wealth', 'lapis-lazuli': 'Wisdom', 'moonstone': 'Intuition',
    'aquamarine': 'Peace'
  };
  // 意图 → 推荐珠子 base（权重可重复，主石出现更多）
  // 以后加装饰：在 INTENTION_CHARM_POOL 里按意图放 charm handle
  var INTENTION_STONE_POOL = {
    selflove: ['rose-quartz','rose-quartz','rose-quartz','strawberry-quartz','strawberry-quartz','amethyst','clear-quartz','clear-quartz'],
    protection: ['black-tourmaline','black-tourmaline','black-tourmaline','tiger-eye','tiger-eye','tiger-eye'],
    abundance: ['citrine','citrine','citrine','tiger-eye','green-aventurine','carnelian','natural-agate','rutilated-quartz'],
    calm: ['amethyst','amethyst','moonstone','moonstone','lapis-lazuli','clear-quartz','aquamarine']
  };
  var INTENTION_CHARM_POOL = {
    selflove: ['heart-charm', 'flower-charm'],
    protection: ['moon-charm', 'star-charm'],
    abundance: ['star-charm', 'flower-charm'],
    calm: ['moon-charm', 'heart-charm']
  };

  function shuffleInPlace(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  function pickRandom(arr) {
    if (!arr || !arr.length) return null;
    return arr[Math.floor(Math.random() * arr.length)];
  }

  /** 从当前意图可选珠里生成一套随机串（尽量填到接近 max 手围的 75%～95%） */
  function buildRandomRecipeItems() {
    if (!state.intention) return [];
    var keys = intentionTagCandidates(state.intention).filter(function (t) {
      return t && t.indexOf('intention:') !== 0;
    });
    var titleKey = String(state.intention.title || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
    if (titleKey && keys.indexOf(titleKey) === -1) keys.push(titleKey);

    var poolBases = null;
    for (var k = 0; k < keys.length; k++) {
      if (INTENTION_STONE_POOL[keys[k]]) { poolBases = INTENTION_STONE_POOL[keys[k]]; break; }
    }

    // 池子：优先意图推荐；否则用当前筛选可见的珠子
    var poolItems = [];
    if (poolBases && poolBases.length) {
      var uniq = {};
      poolBases.forEach(function (b) {
        var it = findBeadByBase(b);
        if (it) {
          poolItems.push(it);
          uniq[it.id] = true;
        }
      });
      // 补上同意图、当前 mm 下其它匹配珠
      filteredBeadOptions().forEach(function (o) {
        if (!uniq[o.id]) { poolItems.push(o); uniq[o.id] = true; }
      });
    } else {
      poolItems = filteredBeadOptions().slice();
    }
    if (!poolItems.length) return [];

    var limits = wristLimits();
    // 目标：贴近最小手围（允许略高 0～一颗珠的余量，避免刚好不够）
    var target = limits.min;
    var targetCap = limits.min + 8; // 最多比最小大约多 8mm（约一颗 8mm）
    if (targetCap > limits.max) targetCap = limits.max;

    var items = [];
    var wrist = 0;
    var guard = 0;

    // 先尽量放入 2～3 种不同材质（仍受最小目标约束）
    var distinct = shuffleInPlace(poolItems.slice());
    var seen = {};
    distinct.forEach(function (it) {
      var base = ((it.handle || '').toLowerCase().replace(/-\d+mm$/i, ''));
      if (seen[base]) return;
      if (items.length >= 3) return;
      var mm = beadMmNumber(it);
      if (wrist + mm > targetCap) return;
      items.push(it);
      wrist += mm;
      seen[base] = true;
    });

    // 填到刚达到/略超过最小手围即停
    while (wrist < target && guard < 50) {
      guard++;
      var room = targetCap - wrist;
      var candidates = poolItems.filter(function (o) {
        return beadMmNumber(o) <= room || wrist + beadMmNumber(o) <= limits.max;
      });
      // 优先能让我们靠近 min 的珠
      if (!candidates.length) {
        candidates = poolItems.filter(function (o) { return wrist + beadMmNumber(o) <= limits.max; });
      }
      if (!candidates.length) break;
      var pick = pickRandom(candidates);
      var mm2 = beadMmNumber(pick);
      if (wrist + mm2 > limits.max) break;
      // 若已经 ≥ min，不再继续加
      if (wrist >= target) break;
      items.push(pick);
      wrist += mm2;
      if (wrist >= target) break;
    }

    if (items.length > 2) shuffleInPlace(items);
    return items;
  }

  /** 预留：随机 0～1 个意图吊坠（池子有配置且商品存在时） */
  function buildRandomRecipeCharms() {
    if (!state.intention) return [];
    var keys = intentionTagCandidates(state.intention).filter(function (t) {
      return t && t.indexOf('intention:') !== 0;
    });
    var titleKey = String(state.intention.title || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
    if (titleKey) keys.push(titleKey);
    var handles = null;
    for (var i = 0; i < keys.length; i++) {
      if (INTENTION_CHARM_POOL[keys[i]] && INTENTION_CHARM_POOL[keys[i]].length) {
        handles = INTENTION_CHARM_POOL[keys[i]];
        break;
      }
    }
    if (!handles || !handles.length) return [];
    // 约 40% 概率带吊坠，避免每次都挂
    if (Math.random() > 0.45) return [];
    var h = pickRandom(handles);
    var charm = charmOptions.find(function (c) {
      var ch = (c.handle || '').toLowerCase();
      return ch === h || ch.indexOf(String(h).toLowerCase()) !== -1;
    });
    return charm ? [charm] : [];
  }



  var beadOptions = [];   // 珠子库原始数据
  var charmOptions = [];  // 吊坠库原始数据（已停用，保留为空以免下游报错）
  var accessoryOptions = [];  // 配饰库原始数据（按款式分类，不按尺寸）
  var isLoading = false;

  // ---------- 工具 ----------
  function formatMoney(cents) {
    // 注意：此处按两位小数显示；无小数货币可自行调整
    var n = Number(cents);
    if (isNaN(n)) n = 0;
    return config.currencySymbol + (n / 100).toFixed(2);
  }

  // ---------- CDN 缩略图 ----------
  // 珠子商品图是原始大图（单张 100–280KB），但列表里只显示 44–52px、
  // 预览圆环里最大也就 ~38px。按真实显示尺寸向 Shopify CDN 取小图，
  // 可把首页图片体积降低约 70%。
  function thumbUrl(url, w) {
    if (!url) return url;
    var u = String(url);
    if (u.indexOf('cdn.shopify.com') === -1) return u;
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function mapCollectionProduct(p) {
    var v = p.variants[0] || {};
    var tags = [];
    if (typeof p.tags === 'string') {
      tags = p.tags.split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
    } else if (Array.isArray(p.tags)) {
      tags = p.tags.map(function (t) { return String(t).trim().toLowerCase(); });
    }
    return {
      id: p.id,
      variantId: v.id,
      handle: p.handle || '',
      title: p.title,
      price: v.price ? Math.round(parseFloat(v.price) * 100) : 0,
      image: p.images && p.images[0] ? p.images[0].src : null,
      // 商品描述（商品页那份文案）→ 进详情卡
      desc: (function () { var raw = (p.body_html || '').replace(/<[^>]*>/g, ' ').replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/\s+/g, ' ').trim(); var cut = raw.search(/Specification\.|How to order\.|Care\./); if (cut > 40) raw = raw.slice(0, cut).trim(); return raw; })(),
      metal: (p.product_type === 'Charm') ? 'Silver-tone brass' : 'Natural stone',
      // 款式分类的来源。配饰栏的筛选按钮就是从它去重生成的。
      productType: p.product_type || '',
      sizeMm: (function () { var m = String(p.title || '').match(/(\d+)\s*mm/i); return m ? m[1] : ''; })(),
      // ── 舞台尺寸（统一数据模型）────────────────────────────────────────
      // 唯一权威来源是 stage:WxH 标签（mm）。没有标签时 itemStageDims() 会退回
      // 「标题/标签里的 mm」推导成正方形，所以新老商品走的是同一条路。
      stage: (function () {
        for (var i = 0; i < tags.length; i++) {
          var m = String(tags[i]).match(/^stage:(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)$/);
          if (m) return { w: parseFloat(m[1]), h: parseFloat(m[2]) };
        }
        return null;
      })(),
      // 【只需要 images[0]】—— 它就是透明底抠图，也是列表缩略图。
      // 不再看 images[1]，也不再看图片张数：
      // 是否抠图完全由 detectCutout() 运行时读四角 alpha 判定（见下）。
      // 初始恒为 false，等检测结果回来再决定重画（检测是双向的）。
      hasCutout: false,
      stageImage: (p.images && p.images[0]) ? p.images[0].src : null,
      // 手动角度偏移（标签 angle:90 / angle:180 / angle:-90…），叠加在自动对齐之上。
      // 用途：自动识别判错、或出图朝向本来就不是标准朝向时的兜底。
      // 不标 = 0，行为与纯自动完全一致。
      angle: (function () {
        for (var ai = 0; ai < tags.length; ai++) {
          var am = String(tags[ai]).match(/^angle:(-?\d+(?:\.\d+)?)$/);
          if (am) { var av = parseFloat(am[1]); return isFinite(av) ? av : 0; }
        }
        return 0;
      })(),
      tags: tags
    };
  }

  /** 分页拉取系列商品（店面 API 每页最多约 50） */
  function fetchCollection(handle) {
    if (!handle) return Promise.resolve([]);
    var all = [];
    function page(n) {
      return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=50&page=' + n)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var list = data.products || [];
          list.forEach(function (p) { all.push(mapCollectionProduct(p)); });
          if (list.length >= 50 && n < 10) return page(n + 1);
          return all;
        });
    }
    return page(1);
  }

  // ---------- 渲染：尺寸 ----------
  function renderSizes() {
    if (!sizesBox || !config.enableSize) return;
    sizesBox.innerHTML = config.wristSizes.map(function (s, i) {
      return '<button type="button" class="diy-bracelet__size-btn' +
        (i === state.sizeIdx ? ' is-active' : '') +
        '" data-idx="' + i + '" data-size="' + escapeHtml(s) + '">' +
        escapeHtml(s) + '"</button>';
    }).join('');
  }

  // ---------- 渲染：意图角标 ----------
  function renderBadge() {
    if (!badgeEl) return;
    if (state.intention) {
      badgeEl.textContent = (state.intention.icon ? state.intention.icon + ' ' : '') + state.intention.title;
      badgeEl.hidden = false;
    } else {
      badgeEl.hidden = true;
    }
  }


  // ---------- 贴合度：说人话（两家竞品都是这么做的） ----------
  function fitState() {
    var n = (state.beads || []).length;
    if (!n) return null;
    var mm = calcWristMm();
    var lim = wristLimits();
    // 低于下限 → 偏紧；下限~下限+20mm → 良好；再往上 → 略松（上限由 canAddBead 挡住）
    if (mm < lim.min) return { kind: 'tight', mm: mm, need: lim.min - mm };
    if (mm <= lim.min + 20) return { kind: 'good', mm: mm };
    return { kind: 'loose', mm: mm };
  }
  function renderFitStatus() {
    var el = document.getElementById('diy-fit-status');
    if (!el) return;
    var f = fitState();
    if (!f) { el.hidden = true; el.className = 'diy-fit-status'; return; }
    // 还需几颗：按当前平均珠径估算
    var avg = 10;
    if (state.beads.length) avg = calcWristMm() / state.beads.length;
    var msg;
    if (f.kind === 'tight') {
      // 只有 1 颗珠子时说「A bit tight」很荒唐（差 130mm 不是「一点点」），
      // 按还需几颗分档说人话。
      var nMore = Math.max(1, Math.round(f.need / Math.max(6, avg)));
      if (nMore >= 4) {
        msg = 'Too small so far — add about ' + nMore + ' more beads.';
      } else if (nMore >= 2) {
        msg = 'Nearly there — add about ' + nMore + ' more beads.';
      } else {
        msg = 'Just a bit tight — add about 1 more bead.';
      }
    } else if (f.kind === 'good') {
      msg = 'Fit looks good';
    } else {
      msg = 'A little loose, but comfortable.';
    }
    el.textContent = msg;
    el.className = 'diy-fit-status diy-fit-status--' + f.kind;
    el.hidden = false;
  }
  function mountFitStatus() {
    if (document.getElementById('diy-fit-status')) return;
    var badge = document.getElementById('diy-bracelet-badge');
    if (!badge || !badge.parentNode) return;
    // 用一行把「意图徽章 + 贴合度」并排放，不额外占一行高度
    var row = document.createElement('div');
    row.className = 'diy-status-row';
    badge.parentNode.insertBefore(row, badge);
    row.appendChild(badge);
    var el = document.createElement('div');
    el.id = 'diy-fit-status';
    el.className = 'diy-fit-status';
    el.hidden = true;
    row.appendChild(el);
  }

  // ---------- 渲染：选项格子 ----------
  function stoneMeaning(item) {
    var h = ((item && item.handle) || '').toLowerCase().replace(/-\d+mm$/i, '');
    return STONE_MEANING[h] || '';
  }

  function optionCardHTML(item, type) {
    var badge = '';
    if (type === 'beads') {
      var n = state.beads.filter(function (b) { return b.id === item.id; }).length;
      if (n > 0) badge = '<span class="diy-bracelet__option-badge">×' + n + '</span>';
    } else {
      var m = state.charms.filter(function (c) { return c.id === item.id; }).length;
      if (m > 0) badge = '<span class="diy-bracelet__option-badge">×' + m + '</span>';
    }
    var img = item.image
      ? '<img class="diy-bracelet__option-img" src="' + escapeHtml(thumbUrl(item.image, 120)) + '"' +
        ' alt="' + escapeHtml(item.title) + '" width="48" height="48"' +
        ' loading="lazy" decoding="async">'
      : '<div class="diy-bracelet__option-img"></div>';
    var meaning = type === 'beads' ? stoneMeaning(item) : '';
    var sub = meaning
      ? '<span class="diy-bracelet__option-sub">' + escapeHtml(meaning) + '</span>'
      : '';
    // 用过的珠子显示 [−] N [+] 步进器（取代原来的 ×N 角标），
    // 一颗都没用过时不占位，保持网格紧凑。
    var used = (type === 'beads')
      ? state.beads.filter(function (b) { return b.id === item.id; }).length
      : state.charms.filter(function (c) { return c.id === item.id; }).length;
    var stepper = used > 0
      ? '<span class="diy-opt-stepper">' +
          '<span class="diy-opt-step" data-act="dec" role="button" tabindex="-1" aria-label="Remove one">\u2212</span>' +
          '<span class="diy-opt-step-n">' + used + '</span>' +
          '<span class="diy-opt-step" data-act="inc" role="button" tabindex="-1" aria-label="Add one">+</span>' +
        '</span>'
      : '';
    // 卡片从 <button> 改为 <div role="button"> —— 步进器不能嵌在 button 里
    return (
      '<div class="diy-bracelet__option" role="button" tabindex="0" data-type="' + type + '" data-id="' + item.id + '">' +
        img +
        '<span class="diy-bracelet__option-name">' + escapeHtml(item.title) + '</span>' +
        sub +
        '<span class="diy-bracelet__option-price">' + formatMoney(item.price) + '</span>' +
        (stepper || badge) +
      '</div>'
    );
  }


  // 按当前意图筛选珠子：
  // 1) intention.stones 配置了商品 handle 列表 → 只显示这些
  // 2) 否则若有 intention.tag → 显示带 tag / intention:tag 的珠子
  // 3) 未选意图 → 显示全部
  function normalizedHandles(list) {
    if (!list || !list.length) return [];
    return list.map(function (h) {
      return String(h || '').trim().toLowerCase().replace(/^\/+|\/+$/g, '');
    }).filter(Boolean);
  }

  function detectBeadMm(item) {
    var tags = item.tags || [];
    var title = (item.title || '').toLowerCase();
    var handle = (item.handle || '').toLowerCase();
    var candidates = ['6', '8', '10', '12'];
    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i]).toLowerCase();
      for (var j = 0; j < candidates.length; j++) {
        if (t === candidates[j] + 'mm' || t === candidates[j] + '-mm' || t === 'size:' + candidates[j] || t === 'mm:' + candidates[j]) {
          return candidates[j];
        }
      }
    }
    var blob = title + ' ' + handle;
    for (var k = 0; k < candidates.length; k++) {
      var re = new RegExp('(^|[^0-9])' + candidates[k] + '\\s*mm\\b');
      if (re.test(blob)) return candidates[k];
    }
    return null;
  }


  /**
   * 尺寸的唯一权威：{ w, h }，单位 mm。
   *   w = 切向尺寸 —— 决定它在环上占多少弧长
   *   h = 径向尺寸 —— 决定它向内/向外伸多少
   * 圆形 w === h，几何上精确退化成以前的「单一直径」。
   *
   * 来源优先级：
   *   1. stage:WxH 标签（回填脚本已给全部商品打上）
   *   2. 旧的 mm 推导（标题或标签里的 6/8/10/12mm）→ 正方形
   *   3. config.defaultBeadMm
   * 三个来源都只影响「怎么得出 w/h」，渲染器只认 w/h。
   */
  function itemStageDims(item) {
    if (item && item.stage && item.stage.w > 0 && item.stage.h > 0) return item.stage;
    var mm = detectBeadMm(item);
    var n = mm ? parseInt(mm, 10) : (config.defaultBeadMm || 8);
    if (!n || isNaN(n)) n = 8;
    return { w: n, h: n };
  }

  function beadMmNumber(item) {
    return itemStageDims(item).w;
  }

  /**
   * 尺寸筛选用的 mm —— 与 itemStageDims 同源（都先看 stage 标签）。
   * 与 itemStageDims 的区别：认不出时返回 null 而不是 defaultBeadMm，
   * 好让筛选逻辑保留「认不出的珠子始终显示」这个安全网（否则会把它们凭空藏掉）。
   */
  function itemFilterMm(item) {
    if (item && item.stage && item.stage.w > 0) return String(item.stage.w);
    return detectBeadMm(item);
  }

  /** 手围 ≈ 所有珠径之和 + 吊坠折算（珠子串成圈时的近似周长） */
  function calcWristMm() {
    var total = 0;
    state.beads.forEach(function (b) { total += beadMmNumber(b); });
    var charmMm = config.charmMm != null ? config.charmMm : 12;
    total += (state.charms.length || 0) * charmMm;
    return total;
  }

  function mmToInch(mm) {
    return (mm / 25.4).toFixed(1);
  }

  function wristLimits() {
    return {
      min: config.minWristMm || 140,
      max: config.maxWristMm || 200
    };
  }

  function canAddBead(item) {
    var limits = wristLimits();
    var next = calcWristMm() + beadMmNumber(item);
    // 唯一硬限制：最大手围（不再用固定颗数 10 卡住）
    if (next > limits.max) return { ok: false, reason: 'wrist_max', next: next };
    // 极端兜底，防止异常死循环（约 40 颗）
    if (state.beads.length >= 40) return { ok: false, reason: 'count_max', next: next };
    return { ok: true, next: next };
  }

  function updateWristUI() {
    var limits = wristLimits();
    var mm = calcWristMm();
    var pct = Math.min(100, Math.round((mm / limits.max) * 100));
    var inch = mmToInch(mm);

    var metric = document.getElementById('diy-lab-wrist-metric');
    if (metric) {
      if (mm > 0) {
        // 弹力绳大约能再伸 1 cm，所以给一个区间而不是单值
        var lo = mm, hi = mm + 10;
        metric.innerHTML =
          '<span class="diy-wrist__range">' + (lo / 10).toFixed(1) + '&ndash;' + (hi / 10).toFixed(1) + ' cm</span>' +
          '<span class="diy-wrist__inch">' + (lo / 25.4).toFixed(1) + '&ndash;' + (hi / 25.4).toFixed(1) + ' in</span>';
      } else {
        metric.textContent = '—';
      }
    }

    if (beadCountEl) {
      beadCountEl.textContent = mm + ' / ' + limits.max + ' mm';
    }

    var valEl = document.getElementById('diy-wrist-meter-value');
    if (valEl) {
      valEl.textContent = mm > 0 ? (mm + ' mm · ' + inch + '"') : '0 mm';
    }
    var fill = document.getElementById('diy-wrist-meter-fill');
    if (fill) {
      fill.style.width = pct + '%';
      fill.classList.remove('is-low', 'is-ok', 'is-full');
      if (mm <= 0) {
        /* empty */
      } else if (mm < limits.min) {
        fill.classList.add('is-low');
      } else if (mm >= limits.max * 0.95) {
        fill.classList.add('is-full');
      } else {
        fill.classList.add('is-ok');
      }
    }
    var bar = document.getElementById('diy-wrist-meter-bar-wrap');
    if (bar) bar.setAttribute('aria-valuenow', String(pct));

    var minMark = document.getElementById('diy-wrist-meter-min-mark');
    if (minMark) {
      minMark.style.left = Math.min(100, Math.round((limits.min / limits.max) * 100)) + '%';
    }
    var minL = document.getElementById('diy-wrist-meter-min-label');
    var maxL = document.getElementById('diy-wrist-meter-max-label');
    if (minL) minL.textContent = 'Min ' + limits.min + ' mm (' + mmToInch(limits.min) + '")';
    if (maxL) maxL.textContent = 'Max ' + limits.max + ' mm (' + mmToInch(limits.max) + '")';

    var hint = document.getElementById('diy-wrist-meter-hint');
    var popularMin = 160, popularMax = 180;
    if (hint) {
      if (mm <= 0) {
        hint.textContent = 'Fit ≈ sum of bead diameters (mm). Add beads to build your size.';
      } else if (mm < limits.min) {
        hint.textContent = 'Below minimum fit. Add more beads (' + (limits.min - mm) + ' mm to go)';
      } else if (mm >= limits.max) {
        hint.textContent = 'Maximum fit reached';
      } else {
        hint.textContent = 'Good range · ' + (limits.max - mm) + ' mm remaining';
      }
    }

    // 自动匹配最近的手腕尺寸选项（英寸）
    syncAutoSize();
  }

  /**
   * 自动把 state.size 对齐到最近的手腕尺码药丸。
   *
   * 为什么单独抽出来：原先这段只在 updateWristUI() 末尾跑，而
   * renderSummary() 是在拼完清单 HTML **之后**才调 updateWristUI() 的 ——
   * 所以清单里的 "Wrist Size: X" 永远读到上一轮的值，比实际下单值慢一档。
   * 实测：20 颗珠时清单显示 6.0"，而真正下单的是 6.5"。
   * 现在 renderSummary() 开头会先调它，保证所有显示点读同一个值。
   * 幂等：同样的手围重复调用结果相同。
   */
  function syncAutoSize() {
    var mm = calcWristMm();
    if (!(config.enableSize && config.wristSizes && config.wristSizes.length && mm > 0)) return;
    var inchNum = mm / 25.4;
    var bestIdx = -1;
    var bestDiff = 999;
    config.wristSizes.forEach(function (s, i) {
      var v = parseFloat(String(s).trim());
      if (isNaN(v)) return;
      var d = Math.abs(v - inchNum);
      if (d < bestDiff) { bestDiff = d; bestIdx = i; }
    });
    if (bestIdx >= 0 && bestDiff <= 0.35) {
      state.sizeIdx = bestIdx;
      state.size = config.wristSizes[bestIdx];
      if (typeof renderSizes === 'function') renderSizes();
    }
  }

  function snapshotState() {
    return JSON.stringify({
      beads: state.beads.map(function (b) { return b.id; }),
      charms: state.charms.map(function (c) { return c.id; }),
      engraving: state.engraving,
      intentionIdx: state.intentionIdx,
      sizeIdx: state.sizeIdx
    });
  }
  function syncUndoRedoBtns() {
    var u = document.getElementById('diy-bracelet-undo');
    var r = document.getElementById('diy-bracelet-redo');
    if (u) u.disabled = !state.history.length;
    if (r) r.disabled = !(state.future && state.future.length);
  }
  function pushHistory() {
    try {
      state.history.push(snapshotState());
      if (state.history.length > 30) state.history.shift();
      state.future = [];
      syncUndoRedoBtns();
    } catch (e) {}
  }


  /** 商品 handle 是否匹配意图配置的珠子（支持 rose-quartz 匹配 rose-quartz-8mm） */
  function handleMatchesStone(productHandle, stoneList) {
    var h = (productHandle || '').toLowerCase();
    var base = h.replace(/-\d+mm$/i, '');
    for (var i = 0; i < stoneList.length; i++) {
      var s = stoneList[i];
      var sBase = s.replace(/-\d+mm$/i, '');
      if (h === s || base === s || base === sBase || h === sBase || h.indexOf(sBase + '-') === 0) {
        return true;
      }
    }
    return false;
  }

  function intentionTagCandidates(intention) {
    var out = [];
    function add(t) {
      t = String(t || '').trim().toLowerCase().replace(/\s+/g, '');
      if (!t) return;
      if (out.indexOf(t) === -1) out.push(t);
      var withPrefix = 'intention:' + t;
      if (out.indexOf(withPrefix) === -1) out.push(withPrefix);
    }
    add(intention.tag);
    var title = String(intention.title || '').trim().toLowerCase();
    var titleMap = {
      'self-love': 'selflove',
      'self love': 'selflove',
      'selflove': 'selflove',
      'protection': 'protection',
      'abundance': 'abundance',
      'calm': 'calm',
      'peace': 'calm',
      'grounding': 'protection',
      'love': 'selflove'
    };
    if (titleMap[title]) add(titleMap[title]);
    add(title.replace(/[^a-z0-9]+/g, ''));
    return out;
  }

  function filteredBeadOptions() {
    // 搜索关键词（PebblePal 式搜索框）
    var __kw = (state.search || '');
    var list = beadOptions;
    if (state.intention) {
      var stones = normalizedHandles(state.intention.stones);
      if (stones.length) {
        list = list.filter(function (o) {
          return handleMatchesStone(o.handle, stones);
        });
      } else {
        var candidates = intentionTagCandidates(state.intention);
        if (candidates.length) {
          list = list.filter(function (o) {
            var tags = o.tags || [];
            for (var i = 0; i < candidates.length; i++) {
              if (tags.indexOf(candidates[i]) !== -1) return true;
            }
            // 标题兜底
            var title = (o.title || '').toLowerCase();
            for (var j = 0; j < stones.length; j++) {}
            return false;
          });
        }
      }
    }
    if (state.sizeMm) {
      list = list.filter(function (o) {
        var mm = itemFilterMm(o);   // 与尺寸换算同源：都先看 stage 标签
        // 无法识别尺寸的珠子在筛选时仍显示，避免库存标签不全时库被筛空
        return !mm || mm === state.sizeMm;
      });
    }
    return list;
  }

  function applySearchFilter(list) {
    var kw = state.search || '';
    if (!kw) return list;
    return list.filter(function (o) {
      return String(o.title || o.name || '').toLowerCase().indexOf(kw) !== -1;
    });
  }

  function renderOptions() {

    if (beadsBox) {
      var beads = applySearchFilter(filteredBeadOptions());
      if (beadOptions.length === 0) {
        beadsBox.innerHTML = '<div class="diy-bracelet__notice">' + escapeHtml(config.emptyBeadsText) + '</div>';
      } else if (beads.length === 0) {
        beadsBox.innerHTML = '<div class="diy-bracelet__notice">No beads match this intention. Try another intention or clear the filter.</div>';
      } else {
        beadsBox.innerHTML = beads.map(function (o) { return optionCardHTML(o, 'beads'); }).join('');
      }
    }
    renderAccessories();
  }

  /** 配饰里出现过的款式（= product_type），去重后排序。
   *  数据驱动：在 Shopify 里新增一个 product_type，筛选按钮自己就长出来。 */
  function accessoryStyles() {
    var seen = {}, out = [];
    accessoryOptions.forEach(function (o) {
      var t = String(o.productType || '').trim();
      if (t && !seen[t]) { seen[t] = 1; out.push(t); }
    });
    return out.sort();
  }

  /** 判断串上的某一项是不是配饰（用来计数，不影响渲染） */
  function isAccessoryItem(it) {
    if (!it) return false;
    for (var i = 0; i < accessoryOptions.length; i++) {
      if (accessoryOptions[i].id === it.id) return true;
    }
    return false;
  }

  function filteredAccessoryOptions() {
    if (!state.style) return accessoryOptions.slice();
    return accessoryOptions.filter(function (o) { return String(o.productType || '') === state.style; });
  }

  /** 配饰栏：款式筛选按钮 + 网格。款式按钮自动生成，不写死任何分类。 */
  function renderAccessories() {
    if (styleFiltersBox) {
      var styles = accessoryStyles();
      var html = '<button type="button" class="diy-bracelet__mm-btn' + (state.style ? '' : ' is-active') +
                 '" data-style="">All</button>';
      styles.forEach(function (t) {
        html += '<button type="button" class="diy-bracelet__mm-btn' + (state.style === t ? ' is-active' : '') +
                '" data-style="' + escapeHtml(t) + '">' + escapeHtml(t) + '</button>';
      });
      styleFiltersBox.innerHTML = styles.length ? html : '';
    }
    if (accessoriesBox) {
      var list = filteredAccessoryOptions();
      accessoriesBox.innerHTML = list.length
        ? list.map(function (o) { return optionCardHTML(o, 'accessories'); }).join('')
        : '<div class="diy-bracelet__notice">' +
          escapeHtml(config.emptyAccessoriesText || 'No accessories in the collection yet.') + '</div>';
    }
    if (accessoryCountEl) {
      accessoryCountEl.textContent = String(state.beads.filter(isAccessoryItem).length);
    }
  }

  // ---------- 渲染：SVG 预览 ----------
  var mobilePlate = window.matchMedia('(max-width: 900px)').matches;
  // 手机圆形托盘：画布正方形；圆环中心略偏下，避免视觉上「整串偏上」
  var SVG_W = mobilePlate ? 320 : 360;
  var SVG_H = mobilePlate ? 320 : 400;
  var CX = mobilePlate ? 160 : 180;
  // 手机 CY 用 52% 高度，给下方吊坠留白，整串在圆盘里更居中
  var CY = mobilePlate ? 160 : 175;
  var R = mobilePlate ? 96 : 95;
  var BEAD_D = mobilePlate ? 34 : 38;
  var CHARM_D = mobilePlate ? 32 : 40;
  var CHARM_BASE_Y = CY + R + (mobilePlate ? 2 : 10);
  var CHARM_ROW_Y = CHARM_BASE_Y + (mobilePlate ? 10 : 18);
  var ENGRAVE_Y = mobilePlate ? Math.min(SVG_H - 14, CY + R + 36) : 352;

  /** 每颗珠的切向尺寸(弧长用) + 径向尺寸 + 按弧长排布的角度（混码不重叠） */
  var layoutBeadSizes = [];
  var layoutBeadH = [];      // 径向尺寸；圆形时与 layoutBeadSizes 完全相同
  var layoutBeadAngles = []; // radians, center angle for each bead

  function applyAdaptiveLayout(beadCount) {
    // 每帧先重置中心，再由 recenter 按内容下移/上移
    if (mobilePlate) {
      CY = SVG_H / 2;
    }
    var beads = state.beads || [];
    var n = beads.length;
    var baseBead = mobilePlate ? 34 : 38;
    var minBead = mobilePlate ? 14 : 16;
    var maxR = mobilePlate ? 100 : 125;
    var minR = mobilePlate ? 64 : 62;
    // 相邻配件之间的额外间距（SVG 单位）。
    // 原本是 3 —— 实测偏大：珠子之间会露出串线，扁盘类配件填不满空隙。
    // 只影响渲染密度，不影响手围计算（手围按珠子 mm 累加）。
    // 想更松/更紧就调这一个数。
    var pad = 1;

    layoutBeadSizes = [];
    layoutBeadH = [];
    layoutBeadAngles = [];

    if (n <= 0) {
      R = mobilePlate ? 86 : 88;
      BEAD_D = baseBead;
      CHARM_BASE_Y = CY + R + (mobilePlate ? 4 : 10);
      CHARM_ROW_Y = CHARM_BASE_Y + (mobilePlate ? 12 : 18);
      ENGRAVE_Y = mobilePlate ? (CY + R + 42) : Math.min(SVG_H - 20, CY + R + 70);
      return;
    }

    // 统一取 {w,h}；圆形 w===h
    var dims = beads.map(function (b) { return itemStageDims(b); });
    // 8mm → baseBead，其余按比例。弧长用 w（切向尺寸）。
    var idealSizes = dims.map(function (dm) { return baseBead * (dm.w / 8); });

    // 周长需求 = Σ直径 + n×缝隙（相邻珠心弧长 = r_i + r_j + pad）
    function circumferenceFor(sizes) {
      var s = 0;
      for (var i = 0; i < sizes.length; i++) s += sizes[i];
      return s + sizes.length * pad;
    }

    var circ = circumferenceFor(idealSizes);
    var idealR = circ / (2 * Math.PI);
    var sizes;

    if (idealR <= maxR) {
      R = Math.max(minR, idealR);
      sizes = idealSizes.slice();
      // 若被抬到 minR，可能略松，保持比例即可
    } else {
      R = maxR;
      var scale = (2 * Math.PI * R) / circ;
      sizes = idealSizes.map(function (d) { return Math.max(minBead, d * scale); });
      // 再压一次，保证 Σ 能绕一圈
      var circ2 = circumferenceFor(sizes);
      if (circ2 > 2 * Math.PI * R) {
        var s2 = (2 * Math.PI * R) / circ2;
        sizes = sizes.map(function (d) { return Math.max(minBead * 0.8, d * s2); });
      }
    }

    layoutBeadSizes = sizes;
    // 径向 = 切向 × (h/w)。圆形时 h/w === 1，结果与 layoutBeadSizes 逐元素相同。
    layoutBeadH = sizes.map(function (sv, i) {
      var dm = dims[i] || { w: 1, h: 1 };
      return dm.w > 0 ? sv * (dm.h / dm.w) : sv;
    });
    BEAD_D = sizes.reduce(function (a, b) { return a + b; }, 0) / n;

    // 按弧长依次排角度：从正上方开始，逆时针
    var angle = -Math.PI / 2;
    //
    // 【闭合修正】—— 这是「珠子少的时候布局变形」的根因。
    //
    // 珠子少时 idealR 比 minR 小，R 被抬到 minR，于是 R > idealR。
    // 此时按弧长累加，Σstep = circ/R < 2π —— 珠子只能绕 3/4 圈甚至更少，
    // 挤在一段弧上、环开着大口。实测：6 颗只占 234°，缺口 126°；
    // 要到 10 颗以上才勉强看起来是闭合的。
    //
    // 修法：环被撑大时改成【等角均分】（360°/n），保证环一定闭合。
    // 环没被撑大时（R === idealR，或 maxR 分支里 sizes 已缩放到能绕满一圈）
    // 仍然按弧长排 —— 这样大小不同的珠子之间缝隙才是均匀的。
    var closedByArc = R <= idealR * 1.0001;
    for (var i = 0; i < n; i++) {
      layoutBeadAngles.push(angle);
      if (closedByArc) {
        var d0 = sizes[i];
        var d1 = sizes[(i + 1) % n];
        var step = (d0 / 2 + d1 / 2 + pad) / R;
        angle += step;
      } else {
        angle += (Math.PI * 2) / n;
      }
    }

    CHARM_BASE_Y = CY + R + (mobilePlate ? 4 : 10);
    CHARM_ROW_Y = CHARM_BASE_Y + (mobilePlate ? 12 : 18);
    ENGRAVE_Y = mobilePlate ? (CY + R + 42) : Math.min(SVG_H - 20, CY + R + 70);
  }

  function beadDisplaySize(i) {
    if (layoutBeadSizes && layoutBeadSizes[i] != null) return layoutBeadSizes[i];
    return BEAD_D;
  }

  /** 第 i 颗的径向尺寸；圆形时等于 beadDisplaySize(i) */
  function beadDisplayH(i) {
    if (layoutBeadH && layoutBeadH[i] != null) return layoutBeadH[i];
    return beadDisplaySize(i);
  }

  function beadAngle(i) {
    if (layoutBeadAngles && layoutBeadAngles[i] != null) return layoutBeadAngles[i];
    var n = Math.max(1, (state.beads || []).length);
    return (-90 + (360 / n) * i) * Math.PI / 180;
  }


  /** 手机端：按当前圆环+吊坠的包围盒，自动把整串放到 viewBox 正中（与屏幕尺寸无关） */
  function recenterPreviewCanvas() {
    if (!mobilePlate) {
      // 桌面保持原逻辑
      return;
    }
    // 内容顶部 ≈ CY - R - BEAD_D/2；底部 ≈ CHARM_ROW_Y + CHARM_D（无吊坠则 CY+R+BEAD_D/2）
    var topY = CY - R - (BEAD_D / 2) - 4;
    var bottomY = CY + R + (BEAD_D / 2) + 4;
    if ((state.charms || []).length) {
      bottomY = Math.max(bottomY, CHARM_ROW_Y + CHARM_D + 6);
    }
    if ((state.engraving || '').length) {
      bottomY = Math.max(bottomY, ENGRAVE_Y + 8);
    }
    // 空状态品牌字
    if (!(state.beads || []).length && !(state.charms || []).length) {
      topY = Math.min(topY, CY - 24);
      bottomY = Math.max(bottomY, CY + 28);
    }
    var contentH = Math.max(1, bottomY - topY);
    // 目标：内容垂直居中于 SVG_H
    var targetTop = (SVG_H - contentH) / 2;
    var shift = targetTop - topY;
    CY += shift;
    CHARM_BASE_Y += shift;
    CHARM_ROW_Y += shift;
    ENGRAVE_Y += shift;
  }


  // ---------- 底盘：SVG 材质托盘 ----------
  var PLATE_R = 150, PLATE_CX = 160, PLATE_CY = 160;
  // 托盘已弃用 —— 走养个石头的路线：纯白背景 + 珠子下方柔和投影。
  // 之前试过 SVG 绘制（迭代三轮仍是"渲染图"）和 AI 生成照片（不好看），
  // 结论：不放托盘最干净，而且不可能显得假。
  function plateMarkup() { return ''; }





  /** 初始化时把托盘插到预览之前（只做一次） */
  function mountPlate() {
    var host = document.querySelector('.diy-lab-plate');
    if (!host || host.querySelector('.diy-plate-svg')) return;
    var markup = plateMarkup();
    if (!markup) return;                 // 托盘已弃用，直接跳过
    var tmp = document.createElement('div');
    tmp.innerHTML = markup;
    if (!tmp.firstChild) return;
    host.insertBefore(tmp.firstChild, host.firstChild);
  }

  /** 珠子落在盘面上的投影（画在珠子之前） */
  function beadShadowsMarkup(beads) {
    var out = '';
    for (var i = 0; i < beads.length; i++) {
      var d = beadDisplaySize(i);
      var a = beadAngle(i);
      var x = CX + R * Math.cos(a);
      var y = CY + R * Math.sin(a);
      out += '<ellipse cx="' + (x + 1.6).toFixed(1) + '" cy="' + (y + d * 0.36).toFixed(1) +
             '" rx="' + (d * 0.53).toFixed(1) + '" ry="' + (d * 0.32).toFixed(1) +
             '" fill="#8A7A66" fill-opacity=".26" filter="url(#ssBeadShadow)"/>';
    }
    return out;
  }

  /**
   * 判断一张图是不是「透明底抠图」。
   * 做法：把图缩到 8×8 画布，看外圈像素的 alpha —— 抠图的外圈必然透明。
   * CDN 发了 access-control-allow-origin:*，所以能读像素（实测通过）。
   * 结果按 URL 缓存，一张图只测一次。
   */
  var __cutoutCache = {};
  function detectCutout(url, cb) {
    if (!url) return cb(false, 1, 1, 1);
    if (__cutoutCache[url] !== undefined) { var cc = __cutoutCache[url]; return cb(cc.cut, cc.aspect, cc.fillW, cc.fillH); }
    if (__cutoutPending[url]) { __cutoutWaiters[url].push(cb); return; }
    __cutoutPending[url] = true; __cutoutWaiters[url] = [cb];
    function finish(v, aspect, fillW, fillH) {
      __cutoutCache[url] = { cut: !!v, aspect: aspect || 1, fillW: fillW || 1, fillH: fillH || 1 };
      delete __cutoutPending[url];
      (__cutoutWaiters[url] || []).forEach(function (f) { try { f(!!v, aspect || 1, fillW || 1, fillH || 1); } catch (e) {} });
      delete __cutoutWaiters[url];
    }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      var ok = false;
      try {
        // 注意：不能把整图缩到小画布 —— 降采样会把透明边和珠子边缘【平均】成
        // 半透明（实测外圈只剩 25% 透明，会被误判成白底图）。
        // 正确做法：从原图直接 1:1 裁四个角，不缩放。
        //   抠图：7% 的透明边在 1400px 上是约 100px，8×8 的角完全落在透明区 → 100%
        //   白底图：角是不透明的白 → 0%
        var W = img.naturalWidth, H = img.naturalHeight, S = 8;
        var c = document.createElement('canvas');
        c.width = c.height = S * 2;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.clearRect(0, 0, S * 2, S * 2);
        x.drawImage(img, 0, 0, S, S, 0, 0, S, S);                 // 左上
        x.drawImage(img, W - S, 0, S, S, S, 0, S, S);             // 右上
        x.drawImage(img, 0, H - S, S, S, 0, S, S, S);             // 左下
        x.drawImage(img, W - S, H - S, S, S, S, S, S, S);         // 右下
        var d = x.getImageData(0, 0, S * 2, S * 2).data;
        var t = 0, n = 0;
        for (var i = 0; i < d.length; i += 4) { n++; if (d[i + 3] < 16) t++; }
        ok = n > 0 && (t / n) > 0.6;

        // 顺便量「内容包围盒长宽比」——用来判断这个配件有没有方向性。
        // 正圆珠子 ≈ 1:1；侧看的隔片（扁盘）≈ 3:1；花托约 1.3–1.6:1。
        // 用中等分辨率降采样：这里只要包围盒，降采样的边缘模糊不影响。
        // ⚠️ 必须【按原比例】缩放绘制。
        // 直接 drawImage(img,0,0,M,M) 会把图强行拉成正方形，
        // 长宽比被破坏 —— 实测 3:1 的隔片会被量成 1.75，真实的 4:1 甚至会被量成 ~1.0，
        // 于是「有方向性」根本识别不出来。
        var M = 96;
        var iw = img.naturalWidth || 1, ih = img.naturalHeight || 1;
        var k = M / Math.max(iw, ih);
        var sw = Math.max(1, Math.round(iw * k)), sh = Math.max(1, Math.round(ih * k));
        var cm = document.createElement('canvas'); cm.width = sw; cm.height = sh;
        var xm = cm.getContext('2d', { willReadFrequently: true });
        xm.clearRect(0, 0, sw, sh);
        xm.drawImage(img, 0, 0, iw, ih, 0, 0, sw, sh);
        var dm = xm.getImageData(0, 0, sw, sh).data;
        var minI = sw, maxI = -1, minJ = sh, maxJ = -1;
        for (var jj = 0; jj < sh; jj++) for (var ii = 0; ii < sw; ii++) {
          if (dm[(jj * sw + ii) * 4 + 3] > 40) {         // 阈值取高一点，避开半透明边
            if (ii < minI) minI = ii; if (ii > maxI) maxI = ii;
            if (jj < minJ) minJ = jj; if (jj > maxJ) maxJ = jj;
          }
        }
        var aspect = 1, fillW = 1, fillH = 1;
        if (maxI >= minI && maxJ >= minJ) {
          var bw = maxI - minI + 1, bh = maxJ - minJ + 1;
          aspect = bw / Math.max(1, bh);
          fillW = bw / sw;      // 内容占画幅的比例
          fillH = bh / sh;
        }
      } catch (e) { ok = false; var aspect = 1, fillW = 1, fillH = 1; }
      finish(ok, aspect, fillW, fillH);
    };
    img.onerror = function () { finish(false); };
    img.src = url;
  }
  var __cutoutPending = {}, __cutoutWaiters = {};

  /**
   * 兜底：某个可选项被加进设计时，如果它的透明/方向检测还没出结果，
   * 单独给它跑一次，完成后重画。
   *
   * 为什么需要：批量检测是异步的，在它完成之前加进去的配件会走
   * 「未知」分支（被裁切 + 无尺寸补偿），看起来【很小】；
   * 而后来加的配件因为检测已完成，尺寸是对的。客户就会看到
   * 「刚加进去的很小，多加几个整体反而变大了」这种诡异现象。
   */
  function ensureDetected(item) {
    if (!item) return;
    var u = item.stageImage || item.image;
    if (!u || __cutoutCache[u] !== undefined) return;   // 已知就不管
    detectCutoutsFor([item], function (changed) {
      if (changed) { renderPreview(); }
    });
  }

  /** 给一批可选项做透明检测，有变化就回报 */
  function detectCutoutsFor(list, onDone) {
    var uniq = {}, pend = 0, changed = false;
    (list || []).forEach(function (o) {
      var u = o && (o.stageImage || o.image);
      if (!u || uniq[u]) return;
      uniq[u] = 1; pend++;
      detectCutout(u, function (isCut, aspect, fillW, fillH) {
        // 双向设置：不能只设 true —— 否则「初始猜 true」的商品永远改不回 false
        // 方向性：长宽比明显偏离正方形 → 这个配件有「朝向」，要按环上切线旋转。
        //   正圆珠 ≈ 1.0      隔片侧看 ≈ 2–4      花托 ≈ 1.3–1.6
        // 阈值 1.35 是从实测分布取的；圆珠不会误判（它们接近 1.0）。
        var directional = isCut && (aspect > 1.35 || aspect < 0.74);
        list.forEach(function (x) {
          if ((x.stageImage || x.image) !== u) return;
          if (!!x.hasCutout !== !!isCut) { x.hasCutout = !!isCut; changed = true; }
          if (!!x.directional !== !!directional) { x.directional = directional; changed = true; }
          // 记录内容占画幅比例 —— 渲染时按它放大，使可见物件正好等于卡槽尺寸。
          // 比固定 1.17 正确：无论出图时留白多少（紧裁 95% / 松裁 45%）都能对上。
          if (x.fillW !== fillW || x.fillH !== fillH) {
            x.fillW = fillW; x.fillH = fillH; changed = true;
          }
        });
        if (--pend === 0 && onDone) onDone(changed);
      });
    });
    if (pend === 0 && onDone) onDone(false);
  }

  function svgImage(x, y, w, href, clipId, h, fit) {
    // h 省略时按正方形（与旧调用完全一致）
    // fit：'slice' = 裁切填满（照片用，与现在一致）；'meet' = 完整放下不裁切（抠图用）
    // clipId 传 null 时不加 clip-path（抠图靠自身透明度成形）
    var hh = (h == null) ? w : h;
    var mode = fit || 'slice';
    return (
      '<image x="' + x + '" y="' + y + '" width="' + w + '" height="' + hh + '" ' +
        'href="' + escapeHtml(thumbUrl(href, 200)) + '" preserveAspectRatio="xMidYMid ' + mode + '" ' +
        (clipId ? 'clip-path="url(#' + clipId + ')" ' : '') + '/>'
    );
  }

  /**
   * 圆 / 椭圆的唯一出口。
   * w === h 时输出 <circle>（与改造前逐像素一致），否则输出 <ellipse>。
   * 所有珠子、吊坠的形状都从这里来 —— 只有一条路。
   */
  function shapeTag(cx, cy, w, h, attrs) {
    if (Math.abs(w - h) < 0.01) {
      return '<circle cx="' + cx + '" cy="' + cy + '" r="' + (w / 2) + '" ' + attrs + ' />';
    }
    return '<ellipse cx="' + cx + '" cy="' + cy + '" rx="' + (w / 2) + '" ry="' + (h / 2) + '" ' + attrs + ' />';
  }

  // ═══════════════════════════════════════════════════════════════════════
  // 珠子绘制层：canvas
  // ---------------------------------------------------------------------------
  // 为什么改成 canvas：原本珠子的 <image> 是在 SVG 里，每次设计变化都要
  // previewBox.innerHTML = ... 整体替换 —— 每个 <image> 被销毁重建，浏览器就会
  // 对同一批 URL 重新发请求（实测拖动一次 8 个、加珠 11 个，每个约 1 秒），
  // 这一秒里整条手链是空的。客户看到的就是「一拖动就白屏 / 变形」。
  //
  // 改成 canvas 后：图片以 Image 对象常驻内存，每帧只是 clearRect + drawImage，
  // 不碰 DOM、不重新下载。crystellediy 用的 BeadDIY 也是这个做法。
  //
  // 分工：
  //   canvas ── 阴影 + 珠子/配饰的图片（贵的、会闪的部分）
  //   SVG    ── 盘子、圆环、刻字、命中区、选中圈（交互层，透明覆盖在 canvas 上）
  // ═══════════════════════════════════════════════════════════════════════
  var previewCanvas = null;
  var __imgCache = {};

  function ensurePreviewCanvas() {
    if (!previewCanvas) {
      previewCanvas = document.createElement('canvas');
      previewCanvas.className = 'diy-preview-canvas';
      previewCanvas.setAttribute('aria-hidden', 'true');
    }
    if (previewCanvas.parentNode !== previewBox) {
      previewBox.insertBefore(previewCanvas, previewBox.firstChild);   // 永远在最底层
    }
    return previewCanvas;
  }

  /** 取一张已解码的图；没就绪就后台加载，加载完回调（用于重画） */
  function previewImage(url, onReady) {
    if (!url) return null;
    var im = __imgCache[url];
    if (!im) {
      im = new Image();
      // 必须带 crossOrigin：Shopify CDN 有 access-control-allow-origin:*。
      // 不带的话预览 canvas 会被判为「跨域污染」，之后 drawShareCard 里
      // 把 canvas 合成进分享卡片/下单设计图时，toDataURL / toBlob 会直接抛
      // SecurityError —— 分享卡片和下单设计图就全废了。
      im.crossOrigin = 'anonymous';
      __imgCache[url] = im;
      im.onload = function () { if (onReady) onReady(); };
      im.onerror = function () { im.__failed = true; if (onReady) onReady(); };
      im.src = url;
    }
    return (im.complete && im.naturalWidth) ? im : null;
  }

  /** 把一个物件（珠/配饰）画到 canvas 上 */
  function paintItem(ctx, item, cx, cy, d, hgt) {
    var src = item.stageImage || item.image;
    if (!src) {                                  // 没图：画个占位
      ctx.fillStyle = '#e4e0d6';
      ctx.beginPath(); ctx.ellipse(cx, cy, d / 2, hgt / 2, 0, 0, Math.PI * 2); ctx.fill();
      return;
    }
    var cut = !!item.hasCutout;
    var url = thumbUrl(src, 200);
    var im = previewImage(url, function () { drawPreviewCanvas(); });
    if (!im) return;                             // 还没就绪：先不画，加载完会重画
    var fw = (cut && item.fillW > 0.05) ? Math.min(1 / item.fillW, 2.6) : (cut ? 1.17 : 1);
    var fh = (cut && item.fillH > 0.05) ? Math.min(1 / item.fillH, 2.6) : (cut ? 1.17 : 1);
    var dw = d * fw, dh = hgt * fh;
    // 物体自身的对齐与旋转都在 canvas 里做，SVG 那边完全不用管
    var rot = (item.__rot || 0) * Math.PI / 180;
    ctx.save();
    ctx.translate(cx, cy);
    if (rot) ctx.rotate(rot);
    if (!cut) {                                  // 白底图：裁成卡槽形状（与旧行为一致）
      ctx.beginPath();
      ctx.ellipse(0, 0, d / 2, hgt / 2, 0, 0, Math.PI * 2);
      ctx.clip();
      // 白底圆（原来画在 SVG 里，一并搬过来）
      ctx.fillStyle = '#fff';
      ctx.beginPath(); ctx.ellipse(0, 0, d / 2, hgt / 2, 0, 0, Math.PI * 2); ctx.fill();
    }
    // 抠图：不裁切，按 contain 比例完整放下
    var sc = Math.min(dw / im.naturalWidth, dh / im.naturalHeight);
    var iw = im.naturalWidth * sc, ih = im.naturalHeight * sc;
    ctx.drawImage(im, -iw / 2, -ih / 2, iw, ih);
    ctx.restore();
  }

  function drawPreviewCanvas() {
    var cv = ensurePreviewCanvas();
    if (!cv) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = SVG_W, H = SVG_H;
    if (cv.width !== Math.round(W * dpr) || cv.height !== Math.round(H * dpr)) {
      cv.width = Math.round(W * dpr);
      cv.height = Math.round(H * dpr);
    }
    var ctx = cv.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);

    // 1) 珠子在盘面上的投影（原来在 SVG 里，现在必须在珠子之前画）
    var beads = state.beads || [];
    beads.forEach(function (b, i) {
      var d = beadDisplaySize(i), a = beadAngle(i);
      var x = CX + R * Math.cos(a), y = CY + R * Math.sin(a);
      ctx.save();
      ctx.globalAlpha = 0.26;
      ctx.fillStyle = '#8A7A66';
      ctx.beginPath(); ctx.ellipse(x + 1.6, y + d * 0.36, d * 0.53, d * 0.32, 0, 0, Math.PI * 2); ctx.fill();
      ctx.restore();
    });

    // 2) 珠子
    beads.forEach(function (b, i) {
      var a = beadAngle(i);
      var cx = CX + R * Math.cos(a), cy = CY + R * Math.sin(a);
      var autoRot = b.directional ? ((a * 180 / Math.PI) + 90) : 0;
      b.__rot = autoRot + (b.angle || 0);
      paintItem(ctx, b, cx, cy, beadDisplaySize(i), beadDisplayH(i));
    });

    // 3) 吊坠
    var charms = state.charms || [];
    var k = charms.length;
    if (k) {
      var rowWidth = k * CHARM_D + (k - 1) * 8;
      charms.forEach(function (c, i) {
        var x = CX - rowWidth / 2 + i * (CHARM_D + 8), y = CHARM_ROW_Y;
        var cw = CHARM_D, chh = CHARM_D;
        if (c.stage) {
          var cb = (config.charmMm != null ? config.charmMm : 12) || 12;
          cw = CHARM_D * (c.stage.w / cb); chh = CHARM_D * (c.stage.h / cb);
        }
        c.__rot = 0;
        paintItem(ctx, c, x + CHARM_D / 2, y + CHARM_D / 2, cw, chh);
      });
    }
  }

  function renderPreview() {
    // 每次设计变化都触发（防抖 2.5 秒）设计图预热
    if (typeof warmDesignImage === 'function') warmDesignImage();
    var beads = state.beads;
    var charms = state.charms;
    var parts = [];
    var defs = [];

    applyAdaptiveLayout(beads.length);

    // 盘面投影滤镜（珠子"放"在盘上，而不是浮着）
    defs.push(
      '<filter id="ssBeadShadow" x="-60%" y="-60%" width="220%" height="220%">' +
        '<feGaussianBlur stdDeviation="3.4"/>' +
      '</filter>'
    );

    // 先铺一层珠子在盘面上的投影
    if (beads.length) parts.push(beadShadowsMarkup(beads));

    // 串线（圆环）— 半径随珠数变化
    parts.push(
      '<circle cx="' + CX + '" cy="' + CY + '" r="' + R + '" class="diy-preview-ring" fill="none" ' +
      'stroke="#c9c2b6" stroke-width="2" />'
    );

    // 珠子：按真实 mm 比例的直径 + 按弧长分配的角度（混码不重叠）
    var n = beads.length;
    beads.forEach(function (b, i) {
      var d = beadDisplaySize(i);      // 切向（弧长已经按它算过）
      var hgt = beadDisplayH(i);       // 径向
      var angle = beadAngle(i);
      var bcx = CX + R * Math.cos(angle);
      var bcy = CY + R * Math.sin(angle);
      var x = bcx - d / 2;
      var y = bcy - hgt / 2;
      // 有舞台图（透明底抠图）→ 不裁切，用 meet 完整放下，靠自身透明度成形
      // 没有舞台图 → 按 w/h 形状裁切（照片填满），与改造前完全一致
      var cut = !!b.hasCutout;
      var src = b.stageImage || b.image;
      // 抠图四周有透明留白，若按卡槽尺寸原样画，可见物件会比它占的弧长小。
      // 按【每张图自己的内容占比】放大 —— 出图留白多少都能对上（紧裁/松裁都行）。
      // 用不到 100% 时给个上限，防止极端值把邻居压掉。
      var fw = (cut && b.fillW > 0.05) ? Math.min(1 / b.fillW, 2.6) : (cut ? 1.17 : 1);
      var fh = (cut && b.fillH > 0.05) ? Math.min(1 / b.fillH, 2.6) : (cut ? 1.17 : 1);
      var dw = cut ? d * fw : d;
      var dh = cut ? hgt * fh : hgt;
      var dx = bcx - dw / 2, dy = bcy - dh / 2;
      var clipId = null;
      if (!cut) {
        clipId = 'bead-clip-' + i;
        defs.push('<clipPath id="' + clipId + '">' + shapeTag(bcx, bcy, d, hgt, '') + '</clipPath>');
      }
      var img = src
        ? svgImage(dx, dy, dw, src, clipId, dh, cut ? 'meet' : 'slice')
        : shapeTag(bcx, bcy, d, hgt, 'fill="#e4e0d6"');
      // ── 朝向 ────────────────────────────────────────────────────────
      // 圆珠怎么转都一样，但有方向性的配件（扁盘隔片、花托、侧挂）必须
      // 跟着【所在位置的线方向】走，否则朝向是错的。
      //   线在环上的切线角 = 位置角 + 90°
      //     12 点(θ=-90°) → 切线水平 → 旋转 0°      （与拍摄规范的「线水平」一致）
      //      3 点(θ=0°)   → 切线垂直 → 旋转 90°
      // 圆珠【不旋转】—— 它们的明暗/高光烤在左上角，转了光位就指向四面八方。
      // 最终角度 = 自动基础对齐（切线）+ 商户手动偏移（angle: 标签）
      // 闻山的做法也是这个结构：「系统先按该位置完成基础对齐，再叠加这里选择的角度」。
      // 区别：他的默认是「保持系统方向」需要人工判断，我这边默认全自动，
      //       只在自动判错时才需要打 angle: 标签修正。
      var autoRot = b.directional ? ((angle * 180 / Math.PI) + 90) : 0;
      var rot = autoRot + (b.angle || 0);
      var imgWrap = rot
        ? '<g transform="rotate(' + rot.toFixed(1) + ' ' + bcx.toFixed(1) + ' ' + bcy.toFixed(1) + ')">' + img + '</g>'
        : img;
      var isSel = (state.selectedBeadIdx === i);
      parts.push(
        '<g class="js-bead-remove js-bead-drag diy-bead-g' + (isSel ? ' is-selected' : '') + '" data-idx="' + i + '" data-type="beads" data-home-x="' + bcx + '" data-home-y="' + bcy + '" data-bead-d="' + d + '" data-bead-rot="' + rot.toFixed(1) + '" style="cursor:pointer">' +
          shapeTag(bcx, bcy, d + 16, hgt + 16, 'class="diy-bead-hit" fill="transparent"') +
          shapeTag(bcx, bcy, d + 6, hgt + 6, 'class="diy-bead-ring" fill="none" stroke="' + (isSel ? '#C4A484' : 'transparent') + '" stroke-width="' + (isSel ? '3' : '2') + '"') +
          (cut ? '' : shapeTag(bcx, bcy, d, hgt, 'fill="#fff"')) +
          imgWrap +
        '</g>'
      );
    });

    // 吊坠（挂在圆环正下方，水平排成一行）
    var k = charms.length;
    var rowWidth = k * CHARM_D + (k - 1) * 8;
    charms.forEach(function (c, i) {
      var x = CX - rowWidth / 2 + i * (CHARM_D + 8);
      var y = CHARM_ROW_Y;
      var cut = !!c.hasCutout;
      var src = c.stageImage || c.image;
      var cw = CHARM_D, chh = CHARM_D;
      if (c.stage) {                       // 吊坠的舞台尺寸相对 charmMm 缩放
        var cb = (config.charmMm != null ? config.charmMm : 12) || 12;
        cw = CHARM_D * (c.stage.w / cb);
        chh = CHARM_D * (c.stage.h / cb);
      }
      var ccx = x + CHARM_D / 2, ccy = y + CHARM_D / 2;
      var clipId = null;
      if (!cut) {
        clipId = 'charm-clip-' + i;
        defs.push('<clipPath id="' + clipId + '">' + shapeTag(ccx, ccy, cw, chh, '') + '</clipPath>');
      }
      // 连接线
      parts.push(
        '<line x1="' + CX + '" y1="' + CHARM_BASE_Y + '" x2="' + (x + CHARM_D / 2) + '" y2="' + (y + 2) + '" stroke="#c9c2b6" stroke-width="2" />'
      );
      var fdw = cut ? cw * 1.17 : cw, fdh = cut ? chh * 1.17 : chh;
      var img = src
        ? svgImage(ccx - fdw / 2, ccy - fdh / 2, fdw, src, clipId, fdh, cut ? 'meet' : 'slice')
        : shapeTag(ccx, ccy, cw, chh, 'fill="#e4e0d6"');
      parts.push(
        '<g class="js-charm-remove" data-idx="' + i + '" data-type="charms">' +
          (cut ? '' : shapeTag(ccx, ccy, cw, chh, 'fill="#fff"')) +
          img +
        '</g>'
      );
    });

    // 刻字（固定显示在手串下方）
    if (state.engraving) {
      parts.push(
        '<text x="' + CX + '" y="' + ENGRAVE_Y + '" text-anchor="middle" font-size="17" fill="#5a4a2f" ' +
        'font-family="Georgia, serif">' + escapeHtml(state.engraving) + '</text>'
      );
    }

    if (n === 0 && charms.length === 0) {
      parts.push(
        '<text x="' + CX + '" y="' + (CY - 14) + '" text-anchor="middle" font-size="16" fill="#8A837C" ' +
        'font-family="Georgia, serif" letter-spacing="0.1em">SPIRIT STRAND</text>'
      );
      parts.push(
        '<text x="' + CX + '" y="' + (CY + 8) + '" text-anchor="middle" font-size="11" fill="#A89F94">' +
        '1. Intention  ·  2. Tap stones  ·  3. Fit</text>'
      );
      parts.push(
        '<text x="' + CX + '" y="' + (CY + 26) + '" text-anchor="middle" font-size="10" fill="#C4B8AE">' +
        '8mm is most popular</text>'
      );
    }

    previewBox.innerHTML =
      '<svg viewBox="0 0 ' + SVG_W + ' ' + SVG_H + '" preserveAspectRatio="xMidYMid meet" role="img" aria-label="Bracelet preview, ' + state.beads.length + ' beads, about ' + calcWristMm() + ' mm fit">' +
        '<defs>' + defs.join('') + '</defs>' +
        parts.join('') +
      '</svg>';

    // SVG 是交互层（透明覆盖在上面），真正的珠子由 canvas 画在下面。
    // canvas 是常驻元素，不随 innerHTML 替换 —— 所以图片永远不会被重新下载。
    drawPreviewCanvas();

    playEntranceAnimations();
    if (typeof renderBeadActions === 'function') renderBeadActions();
    var trust = document.getElementById('diy-trust-line');
    if (trust) {
      if (!state.beads.length) {
        trust.textContent = 'Natural stones · each piece unique';
      } else {
        var sizes = {};
        state.beads.forEach(function (b) { sizes[String(beadMmNumber(b))] = true; });
        var mixed = Object.keys(sizes).length > 1;
        trust.textContent = mixed
          ? 'Mixed sizes · natural stones · each arrangement unique'
          : 'Natural stones · each piece unique · drag to reorder';
      }
    }
  }

  /**
   * 从选珠卡片飞向圆环的轨迹动画
   * state.flyFrom = { x, y, w, h, image } 屏幕坐标（点击时记录）
   */
  function playEntranceAnimations() {
    var svg = previewBox.querySelector('svg');
    if (!svg) return;

    if (state.enterIdx >= 0) {
      var g = svg.querySelector('.diy-bead-g[data-idx="' + state.enterIdx + '"]');
      var fly = state.flyFrom;
      state.flyFrom = null;

      if (g) {
        var hx = parseFloat(g.getAttribute('data-home-x')) || CX;
        var hy = parseFloat(g.getAttribute('data-home-y')) || CY;

        // 目标：圆环上珠子在屏幕中的中心
        var targetScreen = beadGroupToScreenCenter(g, svg);

        // 先隐藏真实珠子，等飞行结束再显示
        g.style.opacity = '0';
        g.style.pointerEvents = 'none';
        g.classList.add('is-entering');

        if (fly && targetScreen) {
          flyBeadGhost(fly, targetScreen, function () {
            // 落位：真实珠子淡入 + 轻微回弹
            if (typeof g.animate === 'function') {
              g.style.opacity = '1';
              g.animate(
                [
                  { transform: 'scale(0.85)', offset: 0 },
                  { transform: 'scale(1.08)', offset: 0.45 },
                  { transform: 'scale(1)', offset: 1 }
                ],
                { duration: 280, easing: 'cubic-bezier(0.22, 1.15, 0.36, 1)' }
              );
            } else {
              g.style.opacity = '1';
            }
            g.style.pointerEvents = '';
            g.classList.remove('is-entering');
          });
        } else {
          // 无起点信息时退化为本地弹出
          g.style.opacity = '1';
          g.style.pointerEvents = '';
          g.classList.remove('is-entering');
        }

        // 圆环轻脉冲
        var ring = svg.querySelector('.diy-preview-ring');
        if (ring && typeof ring.animate === 'function') {
          ring.animate(
            [
              { strokeWidth: 2, stroke: '#E8DFD4' },
              { strokeWidth: 3.2, stroke: '#D4A5A0' },
              { strokeWidth: 2, stroke: '#E8DFD4' }
            ],
            { duration: 520, easing: 'ease-out' }
          );
        }
      }
      state.enterIdx = -1;
    }

    if (state.enterCharmIdx >= 0) {
      var cg = svg.querySelector('.js-charm-remove[data-idx="' + state.enterCharmIdx + '"]');
      var flyC = state.flyFrom;
      state.flyFrom = null;
      if (cg) {
        cg.style.opacity = '0';
        var target = beadGroupToScreenCenter(cg, svg);
        if (flyC && target) {
          flyBeadGhost(flyC, target, function () {
            cg.style.opacity = '1';
            if (typeof cg.animate === 'function') {
              cg.animate(
                [{ transform: 'scale(0.9)' }, { transform: 'scale(1)' }],
                { duration: 220, easing: 'ease-out' }
              );
            }
          });
        } else {
          cg.style.opacity = '1';
        }
      }
      state.enterCharmIdx = -1;
    }
  }

  /** SVG 元素中心 → 屏幕坐标 */
  function beadGroupToScreenCenter(el, svg) {
    try {
      var rect = el.getBoundingClientRect();
      if (rect.width < 1 && rect.height < 1) {
        // 可能尚未布局：用 data-home + svg CTM
        var hx = parseFloat(el.getAttribute('data-home-x'));
        var hy = parseFloat(el.getAttribute('data-home-y'));
        if (!isNaN(hx) && !isNaN(hy) && svg.createSVGPoint) {
          var pt = svg.createSVGPoint();
          pt.x = hx; pt.y = hy;
          var ctm = svg.getScreenCTM();
          if (ctm) {
            var sp = pt.matrixTransform(ctm);
            return { x: sp.x, y: sp.y, size: BEAD_D * (ctm.a || 1) };
          }
        }
      }
      return {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
        size: Math.max(rect.width, rect.height) || 36
      };
    } catch (err) {
      return null;
    }
  }

  /**
   * 在 body 上放一个圆形幽灵珠，沿二次贝塞尔曲线飞向目标
   * from: { x, y, w, h, image }  (屏幕坐标，卡片图片区域)
   * to:   { x, y, size }
   */
  function flyBeadGhost(from, to, onDone) {
    var startX = from.x + from.w / 2;
    var startY = from.y + from.h / 2;
    var startSize = Math.max(28, Math.min(from.w, from.h) * 0.85);
    var endX = to.x;
    var endY = to.y;
    var endSize = Math.max(28, to.size || 36);

    // 控制点：向上弧线（更自然的抛物线）
    var midX = (startX + endX) / 2;
    var midY = Math.min(startY, endY) - Math.max(60, Math.abs(startX - endX) * 0.18);
    // 弧顶不要越过顶部导航栏（顶栏约 54~60px）
    midY = Math.max(midY, 74);

    var ghost = document.createElement('div');
    ghost.className = 'diy-fly-ghost';
    ghost.setAttribute('aria-hidden', 'true');
    if (from.image) {
      ghost.style.backgroundImage = 'url("' + thumbUrl(from.image, 160) + '")';
    } else {
      ghost.style.background = '#e4e0d6';
    }
    ghost.style.width = startSize + 'px';
    ghost.style.height = startSize + 'px';
    ghost.style.left = (startX - startSize / 2) + 'px';
    ghost.style.top = (startY - startSize / 2) + 'px';
    document.body.appendChild(ghost);

    var duration = 520;
    var t0 = null;

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / duration);
      var e = easeInOutCubic(p);

      // 二次贝塞尔
      var u = 1 - e;
      var x = u * u * startX + 2 * u * e * midX + e * e * endX;
      var y = u * u * startY + 2 * u * e * midY + e * e * endY;
      var size = startSize + (endSize - startSize) * e;

      // 轻微旋转 + 缩放呼吸
      var rot = (1 - e) * 18; // 开始略倾，落地摆正
      var scaleBoost = 1 + 0.12 * Math.sin(e * Math.PI);

      ghost.style.width = size + 'px';
      ghost.style.height = size + 'px';
      ghost.style.left = (x - size / 2) + 'px';
      ghost.style.top = (y - size / 2) + 'px';
      ghost.style.transform = 'scale(' + scaleBoost + ') rotate(' + rot + 'deg)';
      ghost.style.opacity = String(0.92 + 0.08 * e);

      if (p < 1) {
        requestAnimationFrame(frame);
      } else {
        // 落地闪光后移除
        ghost.style.transition = 'opacity 0.12s ease, transform 0.12s ease';
        ghost.style.opacity = '0';
        ghost.style.transform = 'scale(0.6)';
        setTimeout(function () {
          if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
          if (typeof onDone === 'function') onDone();
        }, 100);
      }
    }
    requestAnimationFrame(frame);
  }

  // ---------- 渲染：清单 + 总价 ----------
  function renderSummary() {
    // 必须在拼清单之前对齐尺码 —— 否则清单里的 "Wrist Size" 会读到上一轮的
    // state.size，比实际下单值慢一档（见 syncAutoSize 的注释）。
    syncAutoSize();
    var html = '';
    var hasBeadsOrCharms = state.beads.length > 0 || state.charms.length > 0;

    if (!hasBeadsOrCharms && !state.engraving && !state.intention && !state.size) {
      html = '<li class="diy-bracelet__summary-empty">No beads selected yet. Pick a few to start.</li>';
    } else {
      if (state.intention) {
        html +=
          '<li class="diy-bracelet__summary-item">' +
            '<span>Intention: ' + escapeHtml(state.intention.title) + '</span>' +
            '<span></span>' +
          '</li>';
      }
      var grouped = {};
      state.beads.forEach(function (b, i) {
        if (!grouped[b.id]) grouped[b.id] = { title: b.title, price: b.price, count: 0, idx: i };
        grouped[b.id].count += 1;
      });
      Object.keys(grouped).forEach(function (id) {
        var g = grouped[id];
        html +=
          '<li class="diy-bracelet__summary-item">' +
            '<span>' + escapeHtml(g.title) + ' ×' + g.count + '</span>' +
            '<span>' + formatMoney(g.price * g.count) + ' <button type="button" data-remove-bead="' + g.idx + '" aria-label="Remove">✕</button></span>' +
          '</li>';
      });
      state.charms.forEach(function (c, i) {
        html +=
          '<li class="diy-bracelet__summary-item">' +
            '<span>' + escapeHtml(c.title) + '</span>' +
            '<span>' + formatMoney(c.price) + ' <button type="button" data-remove-charm="' + i + '" aria-label="Remove">✕</button></span>' +
          '</li>';
      });
      if (state.size) {
        html +=
          '<li class="diy-bracelet__summary-item">' +
            '<span>Wrist Size: ' + escapeHtml(state.size) + '"</span>' +
            '<span></span>' +
          '</li>';
      }
      if (state.engraving) {
        html +=
          '<li class="diy-bracelet__summary-item">' +
            '<span>Engraving: ' + escapeHtml(state.engraving) + '</span>' +
            '<span>Free</span>' +
          '</li>';
      }
    }
    summaryEl.innerHTML = html;

    var total = (config.basePrice || 0) +
      state.beads.reduce(function (s, b) { return s + b.price; }, 0) +
      state.charms.reduce(function (s, c) { return s + c.price; }, 0);
    totalEl.textContent = formatMoney(total);

    var wristMmNow = calcWristMm();
    var limitsNow = wristLimits();
    var fitOk = !hasBeadsOrCharms || wristMmNow >= limitsNow.min;
    addBtn.disabled = !hasBeadsOrCharms;
    if (!isLoading) {
      addBtn.textContent = config.addLabel || 'Review & Order';
      addBtn.classList.toggle('is-fit-warn', hasBeadsOrCharms && !fitOk);
    }
    var breakEl = document.getElementById('diy-price-breakdown');
    if (breakEl) {
      var base = config.basePrice || 0;
      var beadsSum = state.beads.reduce(function (s, b) { return s + b.price; }, 0);
      var charmsSum = state.charms.reduce(function (s, c) { return s + c.price; }, 0);
      breakEl.textContent = hasBeadsOrCharms
        ? ('Base ' + formatMoney(base) + ' + stones ' + formatMoney(beadsSum) + (charmsSum ? ' + charm ' + formatMoney(charmsSum) : ''))
        : '';
    }
    if (charmCountEl) charmCountEl.textContent = state.charms.length + '/' + config.maxCharms;
    updateWristUI();
    // 每次设计变化都排一次自动保存。
    // 之前只在页面加载时调了一次（那时设计还是空的，被守卫条件挡掉），
    // 等于从来没保存过 —— 刷新就丢设计。
    if (typeof scheduleAutoSave === 'function') scheduleAutoSave();
    var reorderTip = document.querySelector('.diy-reorder-tip');
    if (reorderTip) {
      var showTip = state.beads.length >= 2;
      reorderTip.hidden = !showTip;
      reorderTip.style.display = showTip ? '' : 'none';
      if (showTip) {
        reorderTip.classList.add('is-visible');
        clearTimeout(window.__diyReorderTipTimer);
        window.__diyReorderTipTimer = setTimeout(function () {
          reorderTip.classList.remove('is-visible');
          reorderTip.style.opacity = '0';
        }, 4000);
        reorderTip.style.opacity = '1';
      }
    }
    renderIntentBanner();

    var metricBead = document.getElementById('diy-lab-bead-metric');
    var metricPrice = document.getElementById('diy-lab-price-metric');
    var checkEl = document.getElementById('diy-checkout-checklist');
    if (checkEl) {
      var parts = [];
      parts.push(state.intention ? ('Intention: ' + state.intention.title) : 'Intention: —');
      parts.push(state.beads.length + ' beads · ' + calcWristMm() + ' mm');
      parts.push(state.size ? ('Wrist: ' + state.size + '"') : 'Wrist size: not set');
      if (state.charms.length) parts.push('Charm: yes');
      if (state.engraving) parts.push('Engraving: ' + state.engraving);
      checkEl.textContent = parts.join(' · ');
    }

    if (metricBead) metricBead.textContent = String(state.beads.length);
    if (metricPrice) metricPrice.textContent = formatMoney(total);
    var dockPrice = document.getElementById('diy-lab-dock-price') || document.getElementById('diy-lab-dock-total');
    var dockCount = document.getElementById('diy-lab-dock-count');
    var dockCta = document.getElementById('diy-lab-dock-cta') || document.getElementById('diy-lab-dock-add');
    if (dockPrice) dockPrice.textContent = formatMoney(total);
    if (dockCount) dockCount.textContent = calcWristMm() + ' mm · ' + state.beads.length + ' bead' + (state.beads.length === 1 ? '' : 's');
    if (dockCta) {
      dockCta.disabled = !hasBeadsOrCharms;
      if (hasBeadsOrCharms && typeof fitOk !== 'undefined' && !fitOk) {
        dockCta.textContent = 'Add ' + (limitsNow.min - wristMmNow) + ' mm more stones';
        dockCta.classList.add('is-fit-warn');
      } else {
        dockCta.textContent = 'Add to cart';
        dockCta.classList.remove('is-fit-warn');
      }
    }
  }

  // ---------- 交互 ----------
  function showStatus(msg, isError) {
    statusEl.textContent = msg;
    statusEl.className = 'diy-bracelet__status' + (isError ? ' is-error' : ' is-success');
  }

  function handleOptionClick(e) {
    var infoBtn = e.target.closest('.diy-bracelet__option-info');
    if (infoBtn) {
      e.preventDefault();
      e.stopPropagation();
      var iid = parseInt(infoBtn.getAttribute('data-info-id'), 10);
      var infoItem = beadOptions.find(function (o) { return o.id === iid; });
      if (infoItem) showStoneInfo(infoItem);
      return;
    }
    // 「长按查看实拍图」刚触发过 → 这一次点击不再加珠
    if (state.__longPressed) { state.__longPressed = false; return; }
    // 步进器由 pointerdown 的「按住连发」负责，点击阶段直接跳过
    if (e.target.closest('.diy-opt-step')) { e.preventDefault(); return; }
    var btn = e.target.closest('.diy-bracelet__option');
    if (!btn) return;
    var type = btn.getAttribute('data-type');
    var id = parseInt(btn.getAttribute('data-id'), 10);
    var pool = type === 'beads' ? beadOptions
      : (type === 'accessories' ? accessoryOptions : charmOptions);
    var item = pool.find(function (o) { return o.id === id; });
    if (!item) return;

    // 记录卡片位置，供飞入动画使用（必须在 re-render 之前）
    var imgEl = btn.querySelector('img');
    var rectEl = imgEl || btn;
    var rect = rectEl.getBoundingClientRect();
    state.flyFrom = {
      x: rect.left,
      y: rect.top,
      w: rect.width,
      h: rect.height,
      image: item.image || (imgEl && imgEl.src) || ''
    };

    // 配饰和珠子走**同一条**加料路径：都穿上串、都受手围上限约束、都进 state.beads。
    // 唯一的区别是界面归属和筛选维度（配饰按款式，珠子按尺寸）。
    if (type === 'beads' || type === 'accessories') {
      // 圆环选中替换模式
      if (state.replaceMode && state.selectedBeadIdx >= 0 && state.selectedBeadIdx < state.beads.length) {
        pushHistory();
        state.beads[state.selectedBeadIdx] = item;
        ensureDetected(item);          // 同上
        state.enterIdx = state.selectedBeadIdx;
        state.enterCharmIdx = -1;
        state.replaceMode = false;
        showStatus('Bead replaced.', false);
        state.selectedBeadIdx = -1;
        state.replaceMode = false;
        renderOptions();
        renderPreview();
        renderSummary();
        renderBeadActions();
        return;
      }
      var check = canAddBead(item);
      if (!check.ok) {
        var lim = wristLimits();
        if (check.reason === 'wrist_max') {
          showStatus('Max wrist size is ' + lim.max + ' mm (~' + mmToInch(lim.max) + '"). This bead would make it ' + check.next + ' mm.', true);
        } else {
          showStatus(String(config.beadsFullText || 'Bead limit reached').replace('%s', config.maxBeads), true);
        }
        state.flyFrom = null;
        return;
      }
      pushHistory();
      state.beads.push(item);
      ensureDetected(item);            // 检测没出结果就先跑一次，避免尺寸偏小
      state.enterIdx = state.beads.length - 1;
      state.enterCharmIdx = -1;
      state.selectedBeadIdx = -1;
      state.replaceMode = false;
    } else {
      if (state.charms.length >= config.maxCharms) {
        showStatus('You can add up to ' + config.maxCharms + ' charms.', true);
        state.flyFrom = null;
        return;
      }
      pushHistory();
      state.charms.push(item);
      state.enterCharmIdx = state.charms.length - 1;
      state.enterIdx = -1;
    }
    statusEl.textContent = '';
    renderOptions();
    renderPreview();
    renderSummary();
  }


  // 步进器：加一颗 / 减一颗（复用与点击卡片一致的收尾流程）
  function stepOne(card, act, isRepeat) {
    var type = card.getAttribute('data-type');
    var id = parseInt(card.getAttribute('data-id'), 10);
    var pool = type === 'beads' ? beadOptions
      : (type === 'accessories' ? accessoryOptions : charmOptions);
    var item = pool.find(function (o) { return o.id === id; });
    if (!item) return false;
    if (act === 'inc') {
      if (type === 'beads') {
        var check = canAddBead(item);
        if (!check.ok) {
          var lim = wristLimits();
          showStatus('Max wrist size is ' + lim.max + ' mm (\u2248' + mmToInch(lim.max) + '").', true);
          return false;
        }
        pushHistory();
        state.beads.push(item);
        state.enterIdx = -1;             // 步进器不做飞入动画，避免连点刷屏
      } else {
        if (state.charms.length >= config.maxCharms) return false;
        pushHistory();
        state.charms.push(item);
        state.enterCharmIdx = -1;
      }
    } else {
      var arr = type === 'beads' ? state.beads : state.charms;
      var idx = -1;
      for (var i = arr.length - 1; i >= 0; i--) { if (arr[i].id === id) { idx = i; break; } }
      if (idx === -1) return false;
      pushHistory();
      arr.splice(idx, 1);
      state.enterIdx = -1;
      state.selectedBeadIdx = -1;
    }
    statusEl.textContent = '';
    if (isRepeat) {
      // 连发中：只改数字 + 刷预览。网格整体重绘太贵（会 12 次/秒重建 16 张卡片）
      var nEl = card.querySelector('.diy-opt-step-n');
      var nv = type === 'beads'
        ? state.beads.filter(function (b) { return b.id === id; }).length
        : state.charms.filter(function (c) { return c.id === id; }).length;
      if (nEl) nEl.textContent = nv;
      if (nv <= 0) renderOptions();
    } else {
      renderOptions();
    }
    renderPreview();
    renderSummary();
    if (typeof syncLabMetrics === 'function') syncLabMetrics();
    return true;
  }

  // 按住 + / − 连发：一次按住就能填满，不用点 22 下
  var stepHoldTimer = null;
  function stopStepHold(card) {
    if (stepHoldTimer) { clearTimeout(stepHoldTimer); stepHoldTimer = null; }
    if (card) renderOptions();
  }
  function startStepHold(card, act) {
    stopStepHold(null);
    var delay = 360;
    var fired = 0;
    var tick = function () {
      var ok = stepOne(card, act, fired > 0);
      fired++;
      if (!ok) { stopStepHold(card); return; }
      delay = Math.max(70, delay * 0.7);
      stepHoldTimer = setTimeout(tick, delay);
    };
    tick();
  }

  // 长按珠子 → 看实拍大图
  var longPressTimer = null;
  function closePhotoLightbox() {
    var lb = document.getElementById('diy-photo-lightbox');
    if (lb) lb.remove();
    // 兜底：把可能被锁住的状态全部恢复（真机上出现过关闭后无法滚动）
    state.__longPressed = false;
    document.body.style.overflow = '';
    document.body.style.touchAction = '';
    document.documentElement.style.overflow = '';
    if (longPressTimer) { clearTimeout(longPressTimer); longPressTimer = null; }
    // 清掉可能残留的选区/焦点 —— 它们会让浏览器吃掉后续的滑动手势
    try { var sel = window.getSelection(); if (sel && sel.removeAllRanges) sel.removeAllRanges(); } catch (e) {}
    try { if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); } catch (e) {}
  }
  /** 找一颗珠子的完整信息（详情卡用） */
  function beadInfoBySrc(src) {
    for (var i = 0; i < beadOptions.length; i++) {
      if (beadOptions[i].image && src && src.indexOf(beadOptions[i].image.split('/').pop().split('?')[0]) !== -1) return beadOptions[i];
    }
    for (var j = 0; j < charmOptions.length; j++) {
      if (charmOptions[j].image && src && src.indexOf(charmOptions[j].image.split('/').pop().split('?')[0]) !== -1) return charmOptions[j];
    }
    return null;
  }

  function showPhotoLightbox(src, title) {
    closePhotoLightbox();
    var lb = document.createElement('div');
    lb.id = 'diy-photo-lightbox';
    lb.className = 'diy-photo-lightbox';
    lb.innerHTML =
      '<div class="diy-photo-lightbox__box">' +
        '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(title || '') + '">' +
        (title ? '<p class="diy-photo-lightbox__cap">' + escapeHtml(title) + '</p>' : '') +
        (function () {
          var info = beadInfoBySrc(src);
          if (!info) return '';
          var bits = [];
          if (info.sizeMm) bits.push(info.sizeMm + ' mm');
          if (info.metal) bits.push(info.metal);
          if (info.price) bits.push(formatMoney(info.price));
          var h = bits.length ? '<p class="diy-photo-lightbox__meta">' + escapeHtml(bits.join('  ·  ')) + '</p>' : '';
          if (info.desc) {
            h += '<p class="diy-photo-lightbox__desc">' + escapeHtml(info.desc) + '</p>';
            h += '<p class="diy-photo-lightbox__note">Each bead is naturally unique, so colour, inclusions and pattern vary from the photograph.</p>';
          }
          return h;
        })() +
        '<p class="diy-photo-lightbox__hint">Tap anywhere to close</p>' +
      '</div>';
    // 用 pointerdown 关闭：比 click 更即时，也避免和原生长按菜单抢事件
    lb.addEventListener('pointerdown', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      closePhotoLightbox();
    });
    lb.addEventListener('contextmenu', function (ev) { ev.preventDefault(); });
    document.body.appendChild(lb);
  }
  function mountLongPress() {
    // 网页版长按会触发浏览器原生菜单/选字，这里显式拦掉（这是「按住连发」的前提）
    if (!document.__ssCtxBound) {
      document.__ssCtxBound = true;
      document.addEventListener('contextmenu', function (e) {
        if (e.target.closest && e.target.closest('.diy-bracelet__option, .diy-opt-step, .diy-photo-lightbox')) {
          e.preventDefault();
        }
      }, { passive: false });
    }
    var box = document.getElementById('diy-bracelet-beads');
    var box2 = document.getElementById('diy-bracelet-charms');
    [box, box2].forEach(function (host) {
      if (!host || host.__lpBound) return;
      host.__lpBound = true;
      host.addEventListener('pointerdown', function (e) {
        // ① 步进器：按下即 +/−1，按住连发
        var st = e.target.closest('.diy-opt-step');
        if (st) {
          e.preventDefault();       // 拦掉触摸长按的默认行为（浏览器长按菜单）
          try { e.stopPropagation(); } catch (err) {}
          var sc = st.closest('.diy-bracelet__option');
          if (sc) startStepHold(sc, st.getAttribute('data-act'));
          var stopFn = function () { stopStepHold(sc); };
          document.addEventListener('pointerup', stopFn, { once: true });
          document.addEventListener('pointercancel', stopFn, { once: true });
          return;
        }
        // ② 长按卡片：看实拍大图
        var card = e.target.closest('.diy-bracelet__option');
        if (!card) return;
        var startX = e.clientX, startY = e.clientY;
        var clear = function () { if (longPressTimer) { clearTimeout(longPressTimer); longPressTimer = null; } };
        var cancel = function (ev) {
          if (ev && (Math.abs(ev.clientX - startX) > 10 || Math.abs(ev.clientY - startY) > 10)) clear();
        };
        // 收尾时把 pointermove 摘掉，否则每次长按都会往 host 上挂一个监听器
        var cleanup = function () {
          clear();
          host.removeEventListener('pointermove', cancel);
        };
        host.addEventListener('pointermove', cancel);
        host.addEventListener('pointerup', cleanup, { once: true });
        host.addEventListener('pointercancel', cleanup, { once: true });
        clear();
        longPressTimer = setTimeout(function () {
          longPressTimer = null;
          var img = card.querySelector('img');
          var name = card.querySelector('.diy-bracelet__option-name');
          if (img) {
            state.__longPressed = true;                 // 抑制随后的 click 加珠
            showPhotoLightbox(img.src.replace(/width=\d+/, 'width=800'), name ? name.textContent : '');
            // 若这次点击最终没走到选项处理器，2 秒后也清掉标志，避免吞掉下一次点击
            setTimeout(function () { state.__longPressed = false; }, 2000);
          }
        }, 450);
      });
    });
  }

  // 意图：单选（可取消）
  function handleIntentionClick(e) {
    var btn = e.target.closest('.diy-bracelet__intention');
    if (!btn) return;
    var idx = parseInt(btn.getAttribute('data-idx'), 10);
    var item = config.intentions[idx];
    if (!item) return;
    if (state.intentionIdx === idx) {
      state.intention = null;
      state.intentionIdx = -1;
    } else {
      state.intention = item;
      state.intentionIdx = idx;
    }
    document.querySelectorAll('.diy-bracelet__intention').forEach(function (b) {
      b.classList.toggle('is-active', parseInt(b.getAttribute('data-idx'), 10) === state.intentionIdx);
    });
    var curEl = document.getElementById('diy-bracelet-current-intention');
    if (curEl) {
      curEl.textContent = state.intention ? state.intention.title : '—';
    }
    renderBadge();
    renderOptions();
    renderSummary();
    if (typeof renderIntentBanner === 'function') renderIntentBanner();
  }

  // 尺寸：单选
  function handleSizeClick(e) {
    var btn = e.target.closest('.diy-bracelet__size-btn');
    if (!btn) return;
    var idx = parseInt(btn.getAttribute('data-idx'), 10);
    state.sizeIdx = idx;
    state.size = config.wristSizes[idx] || null;
    updateWristUI();
    renderSizes();
    renderSummary();
  }

  // ---------- 圆环拖拽换序（珠子）+ 点击移除 ----------
  // 拖动时珠子沿圆环跟随指针；松手后按角度落位换序；轻点 = 移除
  var dragState = null;

  function clientToSvgPoint(clientX, clientY) {
    var svg = previewBox.querySelector('svg');
    if (!svg) return { x: CX, y: CY };
    var pt = svg.createSVGPoint();
    pt.x = clientX;
    pt.y = clientY;
    var ctm = svg.getScreenCTM();
    if (!ctm) return { x: CX, y: CY };
    var p = pt.matrixTransform(ctm.inverse());
    return { x: p.x, y: p.y };
  }

  function angleFromCenter(x, y) {
    return Math.atan2(y - CY, x - CX);
  }

  // 与排布一致：正上方为 0，顺时针 0..n
  function angleIndexFromPoint(x, y, n) {
    if (n <= 0) return 0;
    var deg = Math.atan2(y - CY, x - CX) * 180 / Math.PI;
    var fromTop = deg + 90;
    if (fromTop < 0) fromTop += 360;
    if (fromTop >= 360) fromTop -= 360;
    var idx = Math.round(fromTop / 360 * n) % n;
    if (idx < 0) idx += n;
    return idx;
  }

  function ringPoint(angle) {
    return {
      x: CX + R * Math.cos(angle),
      y: CY + R * Math.sin(angle)
    };
  }

  function homeAngleForIndex(i, n) {
    return (-90 + (360 / Math.max(n, 1)) * i) * Math.PI / 180;
  }

  /** 拖动中：被拖珠沿圆环跟随手指；其余珠让出空位并平滑挪动 */
  function paintDragFrame(pointerSvgX, pointerSvgY) {
    var n = state.beads.length;
    if (n < 1 || !dragState) return;
    var from = dragState.idx;
    var ang = angleFromCenter(pointerSvgX, pointerSvgY);
    var follow = ringPoint(ang);
    var target = angleIndexFromPoint(pointerSvgX, pointerSvgY, n);
    dragState.targetIdx = target;

    // 目标顺序：from 移到 target
    var order = [];
    var i;
    for (i = 0; i < n; i++) order.push(i);
    var movedId = order.splice(from, 1)[0];
    order.splice(target, 0, movedId);

    var groups = previewBox.querySelectorAll('.diy-bead-g');
    groups.forEach(function (g) {
      var bi = parseInt(g.getAttribute('data-idx'), 10);
      var homeX = parseFloat(g.getAttribute('data-home-x'));
      var homeY = parseFloat(g.getAttribute('data-home-y'));
      if (bi === from) {
        var dx = follow.x - homeX;
        var dy = follow.y - homeY;
        g.setAttribute('transform', 'translate(' + dx + ',' + dy + ')');
        g.classList.add('is-dragging');
        var ring = g.querySelector('.diy-bead-ring');
        if (ring) {
          ring.setAttribute('stroke', '#D4A5A0');
          ring.setAttribute('stroke-width', '3');
        }
      } else {
        var newPos = order.indexOf(bi);
        var dest = ringPoint(homeAngleForIndex(newPos, n));
        var ox = dest.x - homeX;
        var oy = dest.y - homeY;
        g.setAttribute('transform', 'translate(' + ox + ',' + oy + ')');
        g.classList.remove('is-dragging');
        var ring2 = g.querySelector('.diy-bead-ring');
        if (ring2) {
          ring2.setAttribute('stroke', 'transparent');
        }
      }
    });

    var ghost = previewBox.querySelector('.diy-drag-ghost');
    var svg = previewBox.querySelector('svg');
    if (!ghost && svg) {
      var ns = 'http://www.w3.org/2000/svg';
      ghost = document.createElementNS(ns, 'circle');
      ghost.setAttribute('class', 'diy-drag-ghost');
      ghost.setAttribute('r', '7');
      ghost.setAttribute('fill', '#D4A5A0');
      ghost.setAttribute('opacity', '0.5');
      svg.appendChild(ghost);
      // 软光圈
      var halo = document.createElementNS(ns, 'circle');
      halo.setAttribute('class', 'diy-drag-halo');
      halo.setAttribute('r', String(BEAD_D / 2 + 8));
      halo.setAttribute('fill', 'none');
      halo.setAttribute('stroke', '#D4A5A0');
      halo.setAttribute('stroke-width', '1.5');
      halo.setAttribute('stroke-dasharray', '4 4');
      halo.setAttribute('opacity', '0.7');
      svg.appendChild(halo);
    }
    var haloEl = previewBox.querySelector('.diy-drag-halo');
    if (ghost) {
      ghost.setAttribute('cx', String(follow.x));
      ghost.setAttribute('cy', String(follow.y));
      ghost.setAttribute('visibility', 'visible');
    }
    if (haloEl) {
      haloEl.setAttribute('cx', String(follow.x));
      haloEl.setAttribute('cy', String(follow.y));
      haloEl.setAttribute('visibility', 'visible');
    }
  }

  function clearDragPaint() {
    var ghost = previewBox.querySelector('.diy-drag-ghost');
    if (ghost) ghost.setAttribute('visibility', 'hidden');
    var halo = previewBox.querySelector('.diy-drag-halo');
    if (halo) halo.setAttribute('visibility', 'hidden');
  }

  function handlePreviewPointerDown(e) {
    var el = e.target.closest('.js-bead-remove, .js-charm-remove');
    if (!el) return;
    var type = el.getAttribute('data-type');
    var idx = parseInt(el.getAttribute('data-idx'), 10);
    if (isNaN(idx)) return;
    dragState = {
      type: type,
      idx: idx,
      targetIdx: idx,
      startX: e.clientX,
      startY: e.clientY,
      moved: false,
      historyPushed: false,
      pointerId: e.pointerId
    };
    if (type === 'beads' && state.beads.length > 1) {
      try { previewBox.setPointerCapture(e.pointerId); } catch (err) {}
      previewBox.classList.add('is-bead-dragging');
      el.classList.add('is-dragging');
    }
  }

  function handlePreviewPointerMove(e) {
    if (!dragState) return;
    if (dragState.pointerId !== e.pointerId) return;
    var dx = e.clientX - dragState.startX;
    var dy = e.clientY - dragState.startY;
    if (!dragState.moved && (dx * dx + dy * dy) > 36) {
      dragState.moved = true;
      if (!dragState.historyPushed) {
        pushHistory();
        dragState.historyPushed = true;
      }
    }
    if (!dragState.moved || dragState.type !== 'beads') return;
    if (e.cancelable) e.preventDefault();
    if (state.beads.length < 2) return;
    var svgPt = clientToSvgPoint(e.clientX, e.clientY);
    paintDragFrame(svgPt.x, svgPt.y);
  }

  function handlePreviewPointerUp(e) {
    if (!dragState) return;
    if (dragState.pointerId !== e.pointerId) return;
    var type = dragState.type;
    var idx = dragState.idx;
    var target = typeof dragState.targetIdx === 'number' ? dragState.targetIdx : idx;
    var moved = dragState.moved;
    try { previewBox.releasePointerCapture(e.pointerId); } catch (err) {}
    previewBox.classList.remove('is-bead-dragging');
    clearDragPaint();
    dragState = null;

    if (!moved) {
      if (type === 'beads') {
        // 单击只负责选中（删除/替换走下方按钮）
        state.selectedBeadIdx = idx;
        state.replaceMode = true;
        showStatus('Bead selected. Use Replace or Remove below.', false);
      } else {
        pushHistory();
        state.charms.splice(idx, 1);
        showStatus('Charm removed.', false);
      }
      renderOptions();
      renderPreview();
      renderSummary();
      if (typeof renderBeadActions === 'function') renderBeadActions();
      return;
    }
    state.selectedBeadIdx = -1;
    state.replaceMode = false;
    if (typeof renderBeadActions === 'function') renderBeadActions();

    // 提交换序
    if (type === 'beads' && target !== idx && state.beads.length > 1) {
      var item = state.beads.splice(idx, 1)[0];
      state.beads.splice(target, 0, item);
      showStatus('Order updated. Keep dragging to fine-tune.', false);
    }
    renderPreview();
    renderSummary();
  }

  function handlePreviewPointerCancel(e) {
    if (!dragState) return;
    dragState = null;
    previewBox.classList.remove('is-bead-dragging');
    clearDragPaint();
    renderPreview();
  }

  function handlePreviewClick(e) {
    // 逻辑已并入 pointerup
  }

  // 清单里的移除按钮
  function handleSummaryClick(e) {
    var beadBtn = e.target.closest('[data-remove-bead]');
    if (beadBtn) {
      var beadIdx = parseInt(beadBtn.getAttribute('data-remove-bead'), 10);
      if (!isNaN(beadIdx)) state.beads.splice(beadIdx, 1);
      renderOptions();
      renderPreview();
      renderSummary();
      return;
    }
    var charmBtn = e.target.closest('[data-remove-charm]');
    if (charmBtn) {
      var charmIdx = parseInt(charmBtn.getAttribute('data-remove-charm'), 10);
      if (!isNaN(charmIdx)) state.charms.splice(charmIdx, 1);
      renderOptions();
      renderPreview();
      renderSummary();
    }
  }

  // ---------- 保存 / 分享 / 恢复设计 ----------
  function encodeDesign() {
    return {
      intention: state.intentionIdx,
      size: state.sizeIdx,
      beads: state.beads.map(function (b) { return b.id; }),
      charms: state.charms.map(function (c) { return c.id; }),
      engraving: state.engraving
    };
  }

  function designToURL(design) {
    var params = new URLSearchParams();
    params.set('diy', '1');
    if (design.intention >= 0) params.set('intention', String(design.intention));
    if (design.size >= 0) params.set('size', String(design.size));
    if (design.beads.length) params.set('beads', design.beads.join(','));
    if (design.charms.length) params.set('charms', design.charms.join(','));
    if (design.engraving) params.set('eng', design.engraving);
    return window.location.origin + window.location.pathname + '?' + params.toString();
  }

  function saveDesign() {
    try {
      localStorage.setItem('diy_bracelet_design_v1', JSON.stringify(encodeDesign()));
      showStatus('Design saved on this device.', false);
    } catch (e) {
      showStatus('Could not save: browser storage unavailable.', true);
    }
  }


  function buildShareUrl(extra) {
    var design = encodeDesign();
    // 设计器已独立成页（/pages/design）：分享链接固定指向它，
    // 不能再用 window.location.href —— 否则从首页生成的链接会指向首页。
    var url = new URL('/pages/design', window.location.origin);
    url.searchParams.set('diy', btoa(unescape(encodeURIComponent(JSON.stringify(design)))));
    if (extra && extra.ref) url.searchParams.set('ref', extra.ref);
    if (extra && extra.designName) url.searchParams.set('design', extra.designName);
    url.hash = 'diy-bracelet';
    return url.toString();
  }

  // 社媒分享链接（各平台 share URL）
  function socialLinks(url, text) {
    var u = encodeURIComponent(url);
    var t = encodeURIComponent(text || 'I designed this intention bracelet at Spirit Strand ✨');
    return {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + u,
      twitter: 'https://twitter.com/intent/tweet?url=' + u + '&text=' + t,
      pinterest: 'https://pinterest.com/pin/create/button/?url=' + u + '&description=' + t,
      whatsapp: 'https://wa.me/?text=' + t + '%20' + u,
      email: 'mailto:?subject=' + encodeURIComponent('Spirit Strand design') + '&body=' + t + '%0A%0A' + u
    };
  }

  // 显示社媒分享按钮并填入当前设计链接
  function showSocialShare(link) {
    var box = document.getElementById('diy-bracelet-social');
    if (!box) return;
    var links = socialLinks(link, 'I designed this intention bracelet at Spirit Strand ✨ Order it here: ' + link);
    box.querySelectorAll('[data-social]').forEach(function (a) {
      a.href = links[a.getAttribute('data-social')] || '#';
    });
    box.hidden = false;
  }

  // 把 SVG 里 <image> 的外链替换成 data URI。
  // 必须这么做：SVG 作为 <img> 加载时，浏览器会拦截其内部的外链资源。
  // 同一张图可能出现多次（同款珠子），按 URL 去重只 fetch 一次。
  function inlineSvgImages(svg, done) {
    var clone = svg.cloneNode(true);
    var images = Array.prototype.slice.call(clone.querySelectorAll('image'));
    if (!images.length) { done(clone); return; }

    var urls = [];
    images.forEach(function (im) {
      var href = im.getAttribute('href') || im.getAttribute('xlink:href') || '';
      if (href && href.indexOf('data:') !== 0 && urls.indexOf(href) === -1) urls.push(href);
    });
    if (!urls.length) { done(clone); return; }

    var map = {};
    var pending = urls.length;
    var finished = false;
    // 兜底：6 秒内没取完就用原图继续，避免整张分享卡卡死
    var timer = setTimeout(function () {
      if (finished) return;
      finished = true;
      applyMap();
    }, 6000);

    function applyMap() {
      images.forEach(function (im) {
        var href = im.getAttribute('href') || im.getAttribute('xlink:href') || '';
        if (map[href]) {
          im.setAttribute('href', map[href]);
          im.removeAttribute('xlink:href');
        }
      });
      done(clone);
    }

    urls.forEach(function (u) {
      fetch(u, { mode: 'cors' })
        .then(function (r) { return r.blob(); })
        .then(function (blob) {
          return new Promise(function (res) {
            var fr = new FileReader();
            fr.onload = function () { res(fr.result); };
            fr.onerror = function () { res(null); };
            fr.readAsDataURL(blob);
          });
        })
        .then(function (dataUrl) { if (dataUrl) map[u] = dataUrl; })
        .catch(function () { /* 单张失败不影响整体 */ })
        .then(function () {
          pending--;
          if (pending <= 0 && !finished) {
            finished = true;
            clearTimeout(timer);
            applyMap();
          }
        });
    });
  }

  function drawShareCard(callback) {
    var svg = previewBox && previewBox.querySelector('svg');
    if (!svg || !state.beads.length) {
      if (callback) callback(null);
      return;
    }
    var W = 1080, H = 1350;
    var canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    var ctx = canvas.getContext('2d');
    // background
    ctx.fillStyle = '#F7F1EA';
    ctx.fillRect(0, 0, W, H);
    // soft plate
    ctx.fillStyle = '#FFFCFA';
    roundRect(ctx, 80, 160, W - 160, 820, 40);
    ctx.fill();

    function roundRect(c, x, y, w, h, r) {
      c.beginPath();
      c.moveTo(x + r, y);
      c.arcTo(x + w, y, x + w, y + h, r);
      c.arcTo(x + w, y + h, x, y + h, r);
      c.arcTo(x, y + h, x, y, r);
      c.arcTo(x, y, x + w, y, r);
      c.closePath();
    }

    // title
    ctx.fillStyle = '#2A2623';
    ctx.font = '600 42px Georgia, serif';
    ctx.textAlign = 'center';
    ctx.fillText('SPIRIT STRAND', W / 2, 100);
    ctx.font = '28px system-ui, sans-serif';
    ctx.fillStyle = '#8A837C';
    var intent = state.intention ? state.intention.title : 'Custom design';
    ctx.fillText(intent, W / 2, 145);

    // 先把珠子图片内联进 SVG，否则 SVG 当图片加载时外链会被拦截，
    // 画出来 25 颗珠子会全变成同一个残缺图形。
    inlineSvgImages(svg, function (readySvg) {
      readySvg.setAttribute('width', '900');
      readySvg.setAttribute('height', '900');
      var xml = new XMLSerializer().serializeToString(readySvg);
      var url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml);
      var img = new Image();
      img.onload = function () {
        ctx.drawImage(img, 90, 200, 900, 900);
        // 珠子/配饰的图片已经搬去 canvas 绘制（SVG 只剩交互层），
        // 所以这里必须把预览 canvas 叠上去，否则分享卡片和下单设计图上
        // 一颗珠子都不会有。两层用同一套坐标与 contain 规则，直接拉伸对齐。
        if (previewCanvas && previewCanvas.width) {
          try { ctx.drawImage(previewCanvas, 90, 200, 900, 900); }
          catch (e) { console.warn('DIY bracelet: 合成珠子图层失败', e); }
        }
        ctx.fillStyle = '#5c564f';
        ctx.font = '24px system-ui, sans-serif';
        ctx.fillText(state.beads.length + ' beads · ' + calcWristMm() + ' mm', W / 2, 1080);
        ctx.fillStyle = '#9a9086';
        ctx.font = '22px system-ui, sans-serif';
        ctx.fillText('Natural stones · uniquely yours', W / 2, 1125);
        ctx.fillStyle = '#C4A484';
        ctx.font = '20px system-ui, sans-serif';
        ctx.fillText('spiritstrand.com', W / 2, 1280);
        if (callback) callback(canvas);
      };
      img.onerror = function () {
        if (callback) callback(null);
      };
      img.src = url;
    });
  }

  function shareDesign() {
    if (!state.beads.length) {
      showStatus(config.shareNoDesignText || 'Select some beads first, then share.', true);
      return;
    }
    var link = buildShareUrl({});
    navigator.clipboard.writeText(link).then(function () {
      showStatus('Link copied. Generating share card…', false);
    }).catch(function () {
      prompt('Copy this link:', link);
    });
    showSocialShare(link);

    drawShareCard(function (canvas) {
      if (!canvas) return;
      // show card preview panel
      var panel = document.getElementById('diy-share-card-panel');
      var imgOut = document.getElementById('diy-share-card-img');
      var dl = document.getElementById('diy-share-card-download');
      if (panel && imgOut) {
        var dataUrl = canvas.toDataURL('image/png');
        imgOut.src = dataUrl;
        panel.hidden = false;
        if (dl) {
          dl.href = dataUrl;
          dl.download = 'spirit-strand-design.png';
        }
      }
      // try Web Share API with file
      try {
        canvas.toBlob(function (blob) {
          if (!blob) return;
          var file = new File([blob], 'spirit-strand-design.png', { type: 'image/png' });
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            // optional — user can tap native share from mobile later
            window.__diyShareFile = file;
          }
        }, 'image/png');
      } catch (e) {}
      showStatus('Share card ready. Download or copy the link.', false);
    });
  }

  function openPublishModal() {
    if (!state.beads.length) {
      showStatus(config.shareNoDesignText || 'Select some beads first, then publish.', true);
      return;
    }
    if (publishModal) {
      publishModal.hidden = false;
      if (pubStatus) pubStatus.textContent = '';
    }
  }

  function closePublishModal() {
    if (publishModal) publishModal.hidden = true;
  }

  function publishDesign() {
    var name = (pubName && pubName.value || '').trim();
    var creator = (pubCreator && pubCreator.value || '').trim();
    var intention = (pubIntention && pubIntention.value) || 'Self-Love';
    var story = (pubStory && pubStory.value || '').trim();
    var paypal = (pubPaypal && pubPaypal.value || '').trim();
    var email = (pubEmail && pubEmail.value || '').trim();

    if (!name) { if (pubStatus) pubStatus.textContent = 'Please add a design name.'; return; }
    if (!creator) { if (pubStatus) pubStatus.textContent = 'Please add a creator name.'; return; }
    if (!paypal || paypal.indexOf('@') < 1) {
      if (pubStatus) pubStatus.textContent = 'Please add your PayPal email to receive commissions.';
      return;
    }
    if (email && email.indexOf('@') < 1) {
      if (pubStatus) pubStatus.textContent = 'That email address does not look right.';
      return;
    }

    if (pubConfirm) pubConfirm.disabled = true;
    if (pubStatus) pubStatus.textContent = 'Preparing your design…';

    var design = encodeDesign();

    // 本地草稿兜底（即使后端失败也留一份）
    try {
      var list = JSON.parse(localStorage.getItem('ss_community_submissions_v1') || '[]');
      list.unshift({
        name: name, creator: creator, intention: intention, story: story,
        paypal: paypal, email: email, design: design, createdAt: new Date().toISOString()
      });
      localStorage.setItem('ss_community_submissions_v1', JSON.stringify(list.slice(0, 50)));
      localStorage.setItem('diy_bracelet_design_v1', JSON.stringify(design));
    } catch (e) {}

    var base = String(config.backendUrl || '').replace(/\/+$/, '');
    if (!base) {
      var fallback = buildShareUrl({
        ref: creator.toLowerCase().replace(/[^a-z0-9]+/g, '').slice(0, 16) || 'creator',
        designName: name
      });
      if (pubStatus) pubStatus.textContent = 'Community backend not configured. Saved locally. Link: ' + fallback;
      if (pubConfirm) pubConfirm.disabled = false;
      return;
    }

    // 先把设计图传上去，社区卡片才有预览图（命中缓存时几乎瞬时）
    uploadDesignImage(function (img) {
      if (pubStatus) pubStatus.textContent = 'Submitting…';
      fetch(base + '/api/publish', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Upload-Key': config.uploadKey || '' },
        body: JSON.stringify({
          name: name, creator: creator, intention: intention, story: story,
          paypalEmail: paypal, email: email,
          design: design,
          imageGid: img && img.gid ? img.gid : '',
          // 社区卡片要展示的颗数与总价
          beadCount: (state.beads || []).length,
          price: (typeof parseMoneyText === 'function' && totalEl) ? parseMoneyText(totalEl.textContent) : 0
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j || !j.ok) throw new Error((j && j.error) || 'publish failed');
          var link = j.shareLink || buildShareUrl({});
          try { showSocialShare(link); } catch (e) {}
          if (pubStatus) {
            pubStatus.textContent = "Submitted! We'll review it and email you as soon as it is live. Your personal share link is ready — you can use it right away.";
          }
          showStatus('Design submitted for review. You can share your link now.', false);
          try {
            navigator.clipboard.writeText(
              'I designed this intention bracelet at Spirit Strand \u2728\nShop the design:\n' + link +
              '\n\n(I may earn a commission if you order through my link.)\n#SpiritStrand #IntentionBracelet #CrystalBracelet'
            );
          } catch (e) {}
          setTimeout(function () { closePublishModal(); }, 2800);
        })
        .catch(function (err) {
          console.error('publish error:', err);
          if (pubStatus) pubStatus.textContent = 'Publish failed: ' + (err && err.message ? err.message : 'unknown error');
          if (pubConfirm) pubConfirm.disabled = false;
        });
    });
  }


  // 从 URL 读取参数（合并 location.search 与 location.hash，兼容两种分享链接格式）：
  //  - 正确格式: /?diy=...&design_id=xxx#diy-bracelet
  //  - 旧格式:   /#diy-bracelet?diy=...&design_id=xxx
  function getUrlParams() {
    var params = new URLSearchParams(window.location.search || '');
    var hash = window.location.hash || '';
    var qIdx = hash.indexOf('?');
    if (qIdx > -1) {
      new URLSearchParams(hash.slice(qIdx + 1)).forEach(function (v, k) {
        if (!params.has(k)) params.set(k, v);
      });
    }
    return params;
  }

  // 从 URL 读取设计（兼容两种格式）：
  //  - 新格式：?diy=<base64 完整设计 JSON>（grok 的 buildShareUrl 生成）
  //  - 旧格式：?diy=1&beads=..&charms=..&eng=..（早期版本）
  function readDesignFromURL() {
    var params = getUrlParams();
    var diyRaw = params.get('diy');
    if (!diyRaw) return null;
    if (diyRaw !== '1') {
      // base64 格式：btoa(unescape(encodeURIComponent(JSON.stringify(design))))
      try {
        var json = decodeURIComponent(escape(atob(diyRaw)));
        return JSON.parse(json);
      } catch (e) {
        return null;
      }
    }
    var design = { intention: -1, size: -1, beads: [], charms: [], engraving: '' };
    var it = params.get('intention');
    var sz = params.get('size');
    if (it !== null && it !== '' && !isNaN(parseInt(it, 10))) design.intention = parseInt(it, 10);
    if (sz !== null && sz !== '' && !isNaN(parseInt(sz, 10))) design.size = parseInt(sz, 10);
    design.beads = (params.get('beads') || '').split(',').filter(Boolean).map(Number);
    design.charms = (params.get('charms') || '').split(',').filter(Boolean).map(Number);
    design.engraving = params.get('eng') || '';
    return design;
  }

  // ---------- 从 URL / localStorage 还原设计 ----------
  // restoreDesign() 依赖本函数。早期版本遗漏了定义，导致分享链接、
  // 本地保存的设计、社区设计一律无法载入，控制台报
  // "ReferenceError: applyDesign is not defined"。
  function applyDesign(design) {
    if (!design || typeof design !== 'object') return;
    try {
      // 1) 意图
      if (typeof design.intention === 'number' && design.intention >= 0 && config.intentions[design.intention]) {
        state.intentionIdx = design.intention;
        state.intention = config.intentions[design.intention];
      } else if (design.intention === -1 || design.intention == null) {
        state.intentionIdx = -1;
        state.intention = null;
      }

      // 2) 腕围尺码
      if (typeof design.size === 'number' && design.size >= 0 && config.wristSizes[design.size]) {
        state.sizeIdx = design.size;
        state.size = config.wristSizes[design.size];
      } else if (design.size === -1 || design.size == null) {
        state.sizeIdx = -1;
        state.size = null;
      }

      // 3) 刻字
      state.engraving = design.engraving || '';
      if (engraveInput) engraveInput.value = state.engraving;

      // 4) 珠子：按 id 还原并保持设计原有顺序
      // 注意：配饰也在 state.beads 里，但配饰在 accessoryOptions 中，
      // 只查 beadOptions 会让恢复的设计丢掉配饰 —— 两边都并进来。
      var beadById = {};
      beadOptions.forEach(function (o) { beadById[String(o.id)] = o; });
      accessoryOptions.forEach(function (o) { beadById[String(o.id)] = beadById[String(o.id)] || o; });
      state.beads = (design.beads || [])
        .map(function (id) { return beadById[String(id)]; })
        .filter(Boolean);
      state.beads.forEach(ensureDetected);   // 恢复的设计也要保证透明/方向检测到位

      // 5) 吊坠
      var charmById = {};
      charmOptions.forEach(function (o) { charmById[String(o.id)] = o; });
      var maxCharms = config.maxCharms || 1;
      state.charms = (design.charms || [])
        .map(function (id) { return charmById[String(id)]; })
        .filter(Boolean)
        .slice(0, maxCharms);

      // 6) 若设计里的珠子不是当前 mm 筛选，同步筛选按钮，避免列表与设计不一致
      if (state.beads.length) {
        var mm = String(beadMmNumber(state.beads[0]));
        if (mm && state.sizeMm !== mm) {
          state.sizeMm = mm;
          var mmBoxSync = document.getElementById('diy-bracelet-mm-filters');
          if (mmBoxSync) {
            mmBoxSync.querySelectorAll('.diy-bracelet__mm-btn').forEach(function (b) {
              b.classList.toggle('is-active', b.getAttribute('data-mm') === mm);
            });
          }
        }
      }

      // 7) 同步意图 / 尺码 UI 与撤销按钮
      document.querySelectorAll('.diy-bracelet__intention').forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.getAttribute('data-idx'), 10) === state.intentionIdx);
      });
      var curEl = document.getElementById('diy-bracelet-current-intention');
      if (curEl) curEl.textContent = state.intention ? state.intention.title : '\u2014';
      if (typeof renderSizes === 'function') renderSizes();
      if (typeof renderIntentBanner === 'function') renderIntentBanner();
      if (typeof syncUndoRedoBtns === 'function') syncUndoRedoBtns();
    } catch (err) {
      console.warn('DIY bracelet: applyDesign failed', err);
    }
  }

  function restoreDesign() {
    var design = readDesignFromURL();
    if (!design) {
      try {
        var saved = localStorage.getItem('diy_bracelet_design_v1');
        if (saved) design = JSON.parse(saved);
      } catch (e) {
        design = null;
      }
    }
    if (!design) return;
    applyDesign(design);
    renderOptions();
    renderSizes();
    renderBadge();
    renderPreview();
    renderSummary();
  }

  // ---------- 加购 ----------
  function pulseCartFeedback() {
    var dock = document.getElementById('diy-lab-dock');
    var total = document.getElementById('diy-bracelet-total');
    [dock, total].forEach(function (el) {
      if (!el) return;
      el.classList.remove('is-pulse');
      void el.offsetWidth;
      el.classList.add('is-pulse');
      setTimeout(function () { el.classList.remove('is-pulse'); }, 700);
    });
  }

  // 把连续相同的珠子合并成区间，例如：
  //   1.Gold Rutile Quartz 8mm | 2.Carnelian 8mm | 3-25.Green Aventurine 8mm
  // 保留原始顺序，但避免 25 颗珠子生成 25 段重复文字。
  function groupBeadSequence(beads) {
    var runs = [];
    var list = beads || [];
    for (var i = 0; i < list.length; i++) {
      var name = String(list[i].title || '');
      var last = runs[runs.length - 1];
      if (last && last.name === name) {
        last.end = i + 1;
      } else {
        runs.push({ name: name, start: i + 1, end: i + 1 });
      }
    }
    return runs.map(function (r) {
      return (r.start === r.end ? r.start + '.' : r.start + '-' + r.end + '.') + r.name;
    }).join(' | ');
  }

  // ---------- 设计图上传（供后台订单显示） ----------
  // 用已有的 drawShareCard() 把设计渲染成 PNG，上传到后端，
  // 拿回 Shopify Files 的 GID，再写进行项目属性。
  // 后端未配置 / 上传失败时静默降级：照常加购，只是没有图。
  var designImageCache = { hash: null, gid: null, url: null };

  function currentDesignHash() {
    return JSON.stringify({
      i: state.intentionIdx,
      s: state.sizeIdx,
      b: state.beads.map(function (b) { return b.id; }),
      c: state.charms.map(function (c) { return c.id; }),
      e: state.engraving || ''
    });
  }

  // 稳定的短哈希，用来给上传的设计图起名（同一个设计 → 同一个名字）
  function shortDesignHash(str) {
    var h = 5381;
    for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
    return h.toString(36);
  }

  var designImagePending = null;   // { hash, waiters[] }

  function uploadDesignImage(callback) {
    var backend = String(config.backendUrl || '').replace(/\/+$/, '');
    if (!backend) { callback(null); return; }

    var hash = currentDesignHash();
    // ① 已有缓存 → 直接用
    if (designImageCache.hash === hash && designImageCache.gid) {
      callback(designImageCache);
      return;
    }
    // ② 同一个设计正在上传中 → 挂到那条请求上，不要另开一条。
    //    否则：预热在跑 + 加购又开一条 → 加购那条被页面跳转取消 → 白做。
    if (designImagePending && designImagePending.hash === hash) {
      designImagePending.waiters.push(callback);
      return;
    }

    // ★ 先上锁，再画图。
    //   drawShareCard 最多要 6 秒（内联珠子图有 6 秒兜底），
    //   如果锁等到它的回调里才设置，这 6 秒内并发的调用（预热 + 加购）
    //   就会双双通过上面的检查，各打一次上传 —— 白传、还可能建出重复变体。
    designImagePending = { hash: hash, waiters: [callback] };

    function finish(result) {
      var pend = designImagePending;
      designImagePending = null;
      var ws = (pend && pend.waiters) || [];
      for (var i = 0; i < ws.length; i++) { try { ws[i](result); } catch (e) {} }
    }

    var __t0 = Date.now();
    drawShareCard(function (canvas) {
      var __tInline = Date.now() - __t0;
      console.log('DIY bracelet: ① 生成设计图（内联珠子图）耗时 ' + __tInline + ' ms');
      if (!canvas) { finish(null); return; }

      var group = shortDesignHash(hash);
      var url = backend + '/api/design-image?group=' + encodeURIComponent(group)
        + '&intention=' + encodeURIComponent((state.intention && state.intention.title) || '')
        + (window.__diyPendingPrice != null ? '&price=' + encodeURIComponent(window.__diyPendingPrice) : '');
      var key = config.uploadKey || '';

      function done(j) {
        console.log('DIY bracelet: ② Worker 耗时 ' + (Date.now() - __t0 - __tInline) + ' ms  (总计 ' + (Date.now() - __t0) + ' ms)');
        // 成功判定：有 gid（店铺文件）或 variantId（设计变体）之一即可。
        // 只用 gid 判定会误杀「复用」路径 —— 那条路径走查表，本来就没有新文件。
        if (j && j.ok && (j.gid || j.variantId)) {
          designImageCache = { hash: hash, gid: j.gid || null, url: j.url || '', variantId: j.variantId || null };
          finish(designImageCache);
        } else {
          if (j) console.warn('DIY bracelet: 设计图上传被拒绝', j);
          finish(null);
        }
      }

      // 超时兜底。
      // 注意：这个值必须 > Worker 的实际耗时（实测约 13.5 秒：
      // 内联珠子图最多 6 秒 + Worker 建变体约 7.5 秒）。
      // 原来是 8 秒 —— 那是「只上传一张图」时代的设置，
      // 加了「建设计变体」之后就不够了，请求会在中途被 abort（AbortError）。
      function guard(makeRequest) {
        var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        var timer = setTimeout(function () { if (controller) controller.abort(); }, 18000);
        return makeRequest(controller).then(
          function (v) { clearTimeout(timer); return v; },
          function (e) { clearTimeout(timer); throw e; }
        );
      }

      function requestOpts(contentType, body, controller) {
        return {
          method: 'POST',
          headers: { 'Content-Type': contentType, 'X-Upload-Key': key },
          body: body,
          signal: controller ? controller.signal : undefined
        };
      }

      // 主路径：直接发 PNG 二进制（省 CPU、省流量）
      function sendBlob(blob) {
        guard(function (c) { return fetch(url, requestOpts(blob.type || 'image/jpeg', blob, c)); })
          .then(function (r) { return r.json(); })
          .then(done)
          .catch(function (err) {
            console.warn('DIY bracelet: 设计图上传失败，交给客户决定', err);
            finish(null);   // null 会触发「让客户选择」，不再静默不带图下单
          });
      }

      // 回退路径：老浏览器没有 toBlob，用 base64 JSON
      function sendDataUrl() {
        var dataUrl;
        try { dataUrl = canvas.toDataURL('image/png'); } catch (e) { callback(null); return; }
        guard(function (c) { return fetch(url, requestOpts('application/json', JSON.stringify({ png: dataUrl }), c)); })
          .then(function (r) { return r.json(); })
          .then(done)
          .catch(function (err) {
            console.warn('DIY bracelet: 设计图上传失败，交给客户决定', err);
            finish(null);   // null 会触发「让客户选择」，不再静默不带图下单
          });
      }

      // 用 JPEG 而不是 PNG：同一张 1080×1350 的图，JPEG 约 70KB、PNG 约 205KB。
      // 上传耗时实测从 1.2 秒降到 0.4 秒左右。
      if (typeof canvas.toBlob === 'function') {
        canvas.toBlob(function (blob) { blob ? sendBlob(blob) : sendDataUrl(); }, 'image/jpeg', 0.88);
      } else {
        sendDataUrl();
      }
    });
  }

  function addToCart() {
    if (isLoading) return;
    if (state.beads.length === 0 && state.charms.length === 0) return;

    var wristMmCart = calcWristMm();
    var limCart = wristLimits();
    if (wristMmCart < limCart.min) {
      var need = limCart.min - wristMmCart;
      // 不再用 window.confirm 阻断（移动端体验差），改成"点两次"的温和确认
      var fitSig = state.beads.length + ':' + state.charms.length + ':' + wristMmCart;
      if (window.__diyFitSig !== fitSig) {
        window.__diyFitSig = fitSig;
        addBtn.classList.add('is-fit-warn');
        showStatus('Heads up: your design is about ' + wristMmCart + ' mm, just under our ' + limCart.min +
          ' mm minimum. Add about ' + need + ' mm more stones, or tap "' + (config.addLabel || 'Add to cart') +
          '" again to order it as it is.', false);
        return;
      }
    }
    window.__diyFitSig = '';

    isLoading = true;
    addBtn.disabled = true;
    openPrep();                       // 明确告知「正在准备」，而不是静默等待
    var hasBackend = !!String(config.backendUrl || '').trim();
    if (hasBackend) {
      addBtn.classList.add('is-loading');
      addBtn.textContent = 'Preparing design image…';
      showStatus('Rendering your design image…', false);
    } else {
      addBtn.textContent = 'Adding…';
    }

    // 先生成并上传设计图，再带着图片引用加购（失败则不带图照常加购）
    // 加购时的等待上限：10 秒。
    // 这个数字是算出来的，不是拍的：
    //   内联珠子图（inlineSvgImages 自带 6 秒兜底）
    //   + Worker 建变体（实测 3.2 秒，慢网络可能 6 秒）
    //   = 最坏约 12 秒
    // 所以下限是 10 秒 —— 再短就会在「内联还没做完」时就放弃，
    // 变成每次加购都超时（我第一版设 6 秒就是这个错）。
    // 正常情况预热早就跑完了，根本走不到这里。
    // （Worker 那边有 ctx.waitUntil，会在后台把变体建完，
    //   客户下次加购同一设计会走「复用」路径，2 秒返回。）
    var __designImgResolved = false;
    var __designImgFallback = setTimeout(function () {
      if (__designImgResolved) return;
      __designImgResolved = true;
      // 不再「超时就直接不带图下单」—— 那是静默降级。
      // 交给客户明确选择，和变体轮询超时的处理保持一致。
      console.warn('DIY bracelet: 设计图仍未就绪，交给客户决定');
      setPrepTitle('Taking longer than usual');
      setPrepMessage('Your design image is still being prepared. Keep waiting, or check out now and we will match your design from the saved bead sequence.');
      showPrepActions(false);
      prepWait.onclick = function () {
        hidePrepActions();
        setPrepTitle('Preparing your design…');
        setPrepMessage('Still rendering your design image…');
        __designImgResolved = false;
        uploadDesignImage(function (img) {
          if (__designImgResolved) return;
          __designImgResolved = true;
          __continueAddToCart(img);
        });
        setTimeout(function () {
          if (__designImgResolved) return;
          __designImgResolved = true;
          setPrepTitle('Still not ready');
          setPrepMessage('Your design image could not be prepared. You can check out now and we will match your design from the saved bead sequence.');
          showPrepActions(false);
          prepWait.textContent = 'Close';
          prepAnyway.textContent = 'Check out anyway';
          prepWait.onclick = closePrep;
          prepAnyway.onclick = function () { __continueAddToCart(null, { force: true }); };
        }, 22000);
      };
      prepAnyway.onclick = function () { __continueAddToCart(null, { force: true }); };
    }, 22000);
    try {
      var __cents = (config.basePrice || 0);
      (state.beads || []).forEach(function (b) { __cents += (b.price || 0); });
      (state.charms || []).forEach(function (c) { __cents += (c.price || 0); });
      window.__diyPendingPrice = Math.round(__cents / 100);
    } catch (e) { window.__diyPendingPrice = null; }
    uploadDesignImage(function (designImg) {
      if (__designImgResolved) return;
      __designImgResolved = true;
      clearTimeout(__designImgFallback);
      __continueAddToCart(designImg);
    });

  function __continueAddToCart(designImg, opts) {
    // 设计图没拿到（上传失败/超时），而且客户没有明确说「就这样结账」
    // → 给客户两个选择，绝不静默用底链图下单。
    if (!designImg && !(opts && opts.force)) {
      console.warn('DIY bracelet: 设计图不可用，等待客户选择');
      setPrepTitle('Design image unavailable');
      setPrepMessage('We could not prepare your design preview image. You can try again, or check out now and we will match your design from the saved bead sequence.');
      showPrepActions(false);
      prepWait.textContent = 'Try again';
      prepAnyway.textContent = 'Check out anyway';
      prepWait.onclick = function () {
        hidePrepActions();
        setPrepTitle('Preparing your design…');
        setPrepMessage('Still rendering your design image…');
        uploadDesignImage(function (img) { __continueAddToCart(img); });
        setTimeout(function () {
          setPrepTitle('Still unavailable');
          setPrepMessage('Your design preview could not be prepared.');
          showPrepActions(false);
          prepWait.textContent = 'Close';
          prepAnyway.textContent = 'Check out anyway';
          prepWait.onclick = closePrep;
        }, 8000);
      };
      prepAnyway.onclick = function () { __continueAddToCart(null, { force: true }); };
      return;
    }
    if (!designImg) console.warn('DIY bracelet: 客户选择不带设计图结账');

    // ── Phase 2 Scheme A: ONE priced line item (no per-bead cart lines) ──
    var group = Date.now().toString(36);
    var propGroup = config.properties.group || 'DIY Bracelet';
    var attrs = getUrlParams();
    var attrDesignId = attrs.get('design_id');
    var attrDesign = attrs.get('design');
    var attrRef = attrs.get('ref') || attrs.get('creator');
    var creator = (attrRef && String(attrRef).trim()) ? String(attrRef).trim() : 'anonymous';

    var totalCents = (config.basePrice || 0);
    (state.beads || []).forEach(function (b) { totalCents += (b.price || 0); });
    (state.charms || []).forEach(function (c) { totalCents += (c.price || 0); });
    var expectedExact = (totalCents / 100);
    var roundedDollars = Math.round(expectedExact);
    var pricedMin = (typeof config.pricedMin === 'number') ? config.pricedMin : 20;
    var pricedMax = (typeof config.pricedMax === 'number') ? config.pricedMax : 119;
    var targetAmount = Math.max(pricedMin, Math.min(pricedMax, roundedDollars));

    function nearestAmountInMap(map, want) {
      var keys = Object.keys(map || {}).map(function (k) { return parseInt(k, 10); }).filter(function (n) { return !isNaN(n); });
      if (!keys.length) return null;
      keys.sort(function (a, b) { return a - b; });
      var best = keys[0], bestDiff = Math.abs(keys[0] - want);
      for (var i = 1; i < keys.length; i++) {
        var d = Math.abs(keys[i] - want);
        if (d < bestDiff) { best = keys[i]; bestDiff = d; }
      }
      return best;
    }

    function pickVariantFromMap(map, amount) {
      if (!map) return null;
      if (map[String(amount)]) return { amount: amount, id: map[String(amount)] };
      var near = nearestAmountInMap(map, amount);
      if (near == null) return null;
      return { amount: near, id: map[String(near)] };
    }

    function buildRecipeJson() {
      function row(it) {
        return {
          h: it.handle || '',
          t: it.title || '',
          mm: it.mm || it.sizeMm || null,
          p: it.price || 0,
          v: it.variantId || null
        };
      }
      return JSON.stringify({
        beads: (state.beads || []).map(row),
        charms: (state.charms || []).map(row),
        wristMm: wristMmCart,
        intention: state.intention ? state.intention.title : '',
        size: state.size || null,
        engraving: state.engraving || ''
      });
    }

    function buildBaseProps() {
      var baseProps = {};
      // Compatibility group key (theme setting may still be Chinese)
      baseProps[propGroup] = group;
      baseProps['DIY Bracelet'] = group;

      if (state.intention) baseProps['Intention'] = state.intention.title;
      if (state.size) baseProps['Wrist Size'] = state.size + '"';
      baseProps['Wrist mm'] = String(wristMmCart);
      if (state.beads.length) {
        baseProps['Bead sequence'] = groupBeadSequence(state.beads);
        baseProps['Bead count'] = String(state.beads.length);
      }
      if (state.engraving) baseProps['Engraving'] = state.engraving;
      if (state.designNotes) baseProps['Design notes'] = state.designNotes;
      else if (state.notes) baseProps['Design notes'] = state.notes;

      baseProps['Design ID'] = attrDesignId || group;
      if (attrDesign) baseProps['Design'] = attrDesign;
      baseProps['Creator'] = creator;

      baseProps['_Recipe JSON'] = buildRecipeJson();
      baseProps['_Expected total'] = expectedExact.toFixed(2);
      baseProps['_Priced amount'] = String(targetAmount);

      if (state.beads.length || state.charms.length) {
        baseProps['_Design link'] = buildShareUrl({});
      }
      if (designImg && designImg.gid) {
        if (designImg.url) baseProps['_Design image'] = designImg.url;
        if (designImg.gid) baseProps['_Design image gid'] = designImg.gid;
      }
      // Keep Worker design-variant id for ops, but cart line must be the priced variant
      if (designImg && designImg.variantId) {
        baseProps['_Design variant'] = String(designImg.variantId);
      }
      if (state.charms.length) {
        baseProps['Charms'] = state.charms.map(function (c) { return c.title; }).join(' | ');
      }
      baseProps['Wrist in'] = mmToInch(wristMmCart) + '"';
      return baseProps;
    }

    function finishWithVariant(lineVariantId, meta) {
      if (!lineVariantId) {
        console.warn('DIY bracelet: priced variant unresolved — last-resort baseProductId', config.baseProductId);
        lineVariantId = config.baseProductId;
        meta = meta || { fallback: 'baseProductId' };
      }
      var baseProps = buildBaseProps();
      if (meta && meta.amount != null) baseProps['_Priced amount'] = String(meta.amount);
      if (meta && meta.source) baseProps['_Price source'] = meta.source;

      // Exactly ONE cart line — do NOT push per-bead / per-charm lines
      var items = [{ id: lineVariantId, quantity: 1, properties: baseProps }];

      addBtn.textContent = 'Adding…';

      function postCart(list) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: list })
        }).then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        });
      }

      function goCheckout() {
        closePrep();
        pulseCartFeedback();
        window.location.href = '/checkout';
      }
      function failPrep(err) {
        console.error('DIY bracelet: 加购失败', err);
        setPrepTitle('Something went wrong');
        setPrepMessage('We could not add your design to the cart. Please try again.');
        showPrepActions(true);
        prepWait.textContent = 'Try again';
        prepAnyway.textContent = 'Close';
        prepWait.onclick = function () { closePrep(); isLoading = false; addBtn.disabled = false; addBtn.textContent = config.addLabel || 'Review & Order'; };
        prepAnyway.onclick = function () { closePrep(); isLoading = false; addBtn.disabled = false; addBtn.textContent = config.addLabel || 'Review & Order'; };
      }

      // Priced variants are pre-created — no Worker index wait. Simple add → checkout.
      // Last resort: if priced id rejects, retry once with diy-base (still one line; price may be $0).
      postCart(items)
        .then(goCheckout)
        .catch(function (err) {
          if (String(lineVariantId) === String(config.baseProductId)) return failPrep(err);
          console.warn('DIY bracelet: priced variant add failed, last-resort baseProductId', err);
          var retry = [{ id: config.baseProductId, quantity: 1, properties: baseProps }];
          return postCart(retry).then(goCheckout).catch(failPrep);
        });
    }

    function resolveAndAdd() {
      // Prefer Worker design variant (has preview image on checkout). Price it first when possible.
      var designVariantId = designImg && designImg.variantId ? designImg.variantId : null;
      var priceApi = (config.priceApiUrl || '').replace(/\/+$/, '');
      var uploadKey = config.uploadKey || '';

      function afterPriceThenAdd(variantId, meta) {
        finishWithVariant(variantId, meta || {});
      }

      function setDesignVariantPrice(variantId, dollars, thenFn) {
        if (!priceApi || !variantId) { thenFn(false); return; }
        fetch(priceApi + '/set-variant-price', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Upload-Key': uploadKey },
          body: JSON.stringify({ variantId: variantId, price: dollars })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok && j && j.ok, j: j }; }); })
          .then(function (res) {
            if (res.ok) { thenFn(true); return; }
            console.warn('DIY bracelet: set-variant-price failed', res.j);
            thenFn(false);
          })
          .catch(function (err) {
            console.warn('DIY bracelet: set-variant-price error', err);
            thenFn(false);
          });
      }

      if (designVariantId) {
        setPrepMessage('Applying design image & price…');
        setDesignVariantPrice(designVariantId, targetAmount, function (priced) {
          if (priced) {
            afterPriceThenAdd(designVariantId, { amount: targetAmount, source: 'design-variant-priced' });
            return;
          }
          // Price API unavailable: still use design variant for image (may be $0) — better than losing image.
          // Also try priced ladder as fallback only if design variant clearly unusable.
          console.warn('DIY bracelet: using design variant for checkout image; price API not available');
          afterPriceThenAdd(designVariantId, { amount: targetAmount, source: 'design-variant-image-only' });
        });
        return;
      }

      var map = config.pricedVariantMap || {};
      var picked = pickVariantFromMap(map, targetAmount);
      if (picked && picked.id) {
        finishWithVariant(picked.id, { amount: picked.amount, source: 'config-map' });
        return;
      }

      var handle = config.pricedProductHandle || 'custom-intention-bracelet';
      setPrepMessage('Resolving bracelet price…');
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('priced product HTTP ' + r.status);
          return r.json();
        })
        .then(function (prod) {
          var fmap = {};
          (prod.variants || []).forEach(function (v) {
            var label = (v.option1 || v.title || '').replace(/^\$/, '').trim();
            var n = parseInt(label, 10);
            if (!isNaN(n)) fmap[String(n)] = v.id;
          });
          var p2 = pickVariantFromMap(fmap, targetAmount);
          if (p2 && p2.id) {
            finishWithVariant(p2.id, { amount: p2.amount, source: 'product.js' });
          } else {
            console.warn('DIY bracelet: no priced variant near $' + targetAmount);
            finishWithVariant(null, { source: 'none' });
          }
        })
        .catch(function (err) {
          console.warn('DIY bracelet: priced product fetch failed', err);
          finishWithVariant(null, { source: 'fetch-fail' });
        });
    }

resolveAndAdd();
    }
  }

  // ── 复核抽屉 ──────────────────────────────────────────────────────────
  function money(c) { return config.currencySymbol + (c / 100).toFixed(2); }
  function renderReview() {
    if (!reviewBody) return;
    var beads = state.beads || [], accs = [];
    var rows = {};
    beads.forEach(function (b) {
      if (typeof isAccessoryItem === 'function' && isAccessoryItem(b)) { accs.push(b); return; }
      var k = (b.title || '') + '|' + (b.price || 0);
      rows[k] = rows[k] || { title: b.title, price: b.price, n: 0 };
      rows[k].n++;
    });
    var accRows = {};
    accs.forEach(function (b) {
      var k = (b.title || '') + '|' + (b.price || 0);
      accRows[k] = accRows[k] || { title: b.title, price: b.price, n: 0 };
      accRows[k].n++;
    });
    var mm = calcWristMm();
    var lim = wristLimits();
    var total = (config.basePrice || 0) + beads.reduce(function (a, b) { return a + (b.price || 0); }, 0) +
                (state.charms || []).reduce(function (a, c) { return a + (c.price || 0); }, 0);
    function list(obj) {
      return Object.keys(obj).map(function (k) {
        var r = obj[k];
        return '<li class="diy-review__row"><span class="diy-review__name">' + escapeHtml(r.title) +
               '</span><span class="diy-review__qty">&times;' + r.n + '</span>' +
               '<span class="diy-review__price">' + money(r.price * r.n) + '</span></li>';
      }).join('');
    }
    var fitNote = mm < lim.min
      ? '<p class="diy-review__warn">About ' + (lim.min - mm) + ' mm under our ' + lim.min + ' mm minimum.</p>'
      : (mm > lim.max ? '<p class="diy-review__warn">Over our ' + lim.max + ' mm maximum.</p>' : '');
    reviewBody.innerHTML =
      '<div class="diy-review__preview" id="diy-review-preview"></div>' +
      '<dl class="diy-review__facts">' +
        '<div><dt>Total</dt><dd class="diy-review__total">' + money(total) + '</dd></div>' +
        '<div><dt>Wrist</dt><dd>' + mmToInch(mm) + '" &middot; ' + mm + ' mm</dd></div>' +
        '<div><dt>Items</dt><dd>' + beads.length + ' stones' + (accs.length ? ' &middot; ' + accs.length + ' accessories' : '') + '</dd></div>' +
      '</dl>' + fitNote +
      (beads.length - accs.length ? '<h3 class="diy-review__h">Stones</h3><ul class="diy-review__list">' + list(rows) + '</ul>' : '') +
      (accs.length ? '<h3 class="diy-review__h">Accessories</h3><ul class="diy-review__list">' + list(accRows) + '</ul>' : '');
    // 把当前预览 SVG 复制进抽屉
    var host = document.getElementById('diy-review-preview');
    var src = document.querySelector('#diy-bracelet-preview svg');
    if (host && src) host.appendChild(src.cloneNode(true));
  }
  function openReview() {
    if (!reviewEl) return;
    if (state.beads.length === 0 && state.charms.length === 0) return;
    renderReview();
    reviewEl.hidden = false;
    document.body.classList.add('diy-review-open');
    requestAnimationFrame(function () { reviewEl.classList.add('is-open'); });
  }
  function closeReview() {
    if (!reviewEl) return;
    reviewEl.classList.remove('is-open');
    document.body.classList.remove('diy-review-open');
    setTimeout(function () { reviewEl.hidden = true; }, 260);
  }

  // ── 准备弹窗 ──────────────────────────────────────────────────────────
  function setPrepTitle(t) { var e = document.getElementById('diy-prep-title'); if (e) e.textContent = t; }
  function setPrepMessage(t) { if (prepMsgEl) prepMsgEl.textContent = t; }
  function showPrepActions(isError) {
    if (!prepActionsEl) return;
    prepActionsEl.hidden = false;
    if (!isError) { prepWait.textContent = 'Keep waiting'; prepAnyway.textContent = 'Check out anyway'; }
  }
  function hidePrepActions() { if (prepActionsEl) prepActionsEl.hidden = true; }
  function openPrep() {
    if (!prepEl) return;
    prepEl.hidden = false; hidePrepActions();
    setPrepTitle('Preparing your design…');
    setPrepMessage('Rendering your design image and reserving it for checkout.');
    requestAnimationFrame(function () { prepEl.classList.add('is-open'); });
  }
  function closePrep() {
    if (!prepEl) return;
    prepEl.classList.remove('is-open');
    setTimeout(function () { prepEl.hidden = true; }, 200);
  }
  var prepWait = document.getElementById('diy-prep-wait');
  var prepAnyway = document.getElementById('diy-prep-anyway');

  /* ------------------------------------------------------------------
     预热设计图
     ------------------------------------------------------------
     实测时间线：
       内联珠子图（inlineSvgImages 有 6 秒兜底）
     + Worker 建变体（实测 7.5 秒）
     = 最长 13.5 秒  >  前端超时
     超时后请求被取消 → 变体没建成 → 结账页只能显示中性图。

     所以：客户每次改设计后，延迟 2.5 秒在后台把图生成好并上传。
     等他点「Add to cart」时通常已经准备好了，等待接近 0。
     uploadDesignImage 自带按设计 hash 的缓存，不会重复上传。
     ------------------------------------------------------------------ */
  var warmTimer = null;
  function warmDesignImage() {
    if (!config.backendUrl) return;
    if (!state.beads.length) return;
    if (warmTimer) clearTimeout(warmTimer);
    warmTimer = setTimeout(function () {
      warmTimer = null;
      try {
        uploadDesignImage(function (r) {
          if (r && r.variantId) console.log('DIY bracelet: 设计图已预热 ✓（变体约 5-9 秒后才可购买，所以这步越早越好）');
        });
      } catch (e) { /* 预热失败无所谓，加购时还会再试 */ }
    }, 1000);
  }

  // ---------- 事件绑定 ----------

  // mm size filter
  var mmBox = document.getElementById('diy-bracelet-mm-filters');
  if (mmBox) {
    mmBox.addEventListener('click', function (e) {
      var btn = e.target.closest('.diy-bracelet__mm-btn');
      if (!btn) return;
      state.sizeMm = btn.getAttribute('data-mm') || '8';
      mmBox.querySelectorAll('.diy-bracelet__mm-btn').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
      renderOptions();
    });
  }

  // 配饰款式筛选。按钮是 renderAccessories() 从 product_type 自动生成的，
  // 点击只改 state.style 并重画配饰栏 —— 不影响尺寸筛选。
  if (styleFiltersBox) {
    styleFiltersBox.addEventListener('click', function (e) {
      var btn = e.target.closest('.diy-bracelet__mm-btn');
      if (!btn) return;
      state.style = btn.getAttribute('data-style') || '';
      renderAccessories();
    });
  }

  function undoLast() {
    if (!state.history.length) {
      showStatus('Nothing to undo.', true);
      return;
    }
    try {
      state.future = state.future || [];
      state.future.push(snapshotState());
      var snap = JSON.parse(state.history.pop());
      state.beads = (snap.beads || []).map(function (id) {
        return beadOptions.find(function (o) { return o.id === id; });
      }).filter(Boolean);
      state.charms = (snap.charms || []).map(function (id) {
        return charmOptions.find(function (o) { return o.id === id; });
      }).filter(Boolean);
      state.engraving = snap.engraving || '';
      if (engraveInput) engraveInput.value = state.engraving;
      state.intentionIdx = typeof snap.intentionIdx === 'number' ? snap.intentionIdx : -1;
      state.intention = state.intentionIdx >= 0 ? (config.intentions[state.intentionIdx] || null) : null;
      state.sizeIdx = typeof snap.sizeIdx === 'number' ? snap.sizeIdx : -1;
      state.size = state.sizeIdx >= 0 ? (config.wristSizes[state.sizeIdx] || null) : null;
      document.querySelectorAll('.diy-bracelet__intention').forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.getAttribute('data-idx'), 10) === state.intentionIdx);
      });
      var curEl = document.getElementById('diy-bracelet-current-intention');
      if (curEl) curEl.textContent = state.intention ? state.intention.title : '—';
      renderBadge();
      renderOptions();
      renderSizes();
      renderPreview();
      renderSummary();
      if (typeof renderIntentBanner === 'function') renderIntentBanner();
      syncUndoRedoBtns();
    } catch (e) {
      showStatus('Could not undo.', true);
    }
  }

  function redoLast() {
    if (!state.future || !state.future.length) {
      showStatus('Nothing to redo.', true);
      return;
    }
    try {
      state.history.push(snapshotState());
      var snap = JSON.parse(state.future.pop());
      state.beads = (snap.beads || []).map(function (id) {
        return beadOptions.find(function (o) { return o.id === id; });
      }).filter(Boolean);
      state.charms = (snap.charms || []).map(function (id) {
        return charmOptions.find(function (o) { return o.id === id; });
      }).filter(Boolean);
      state.engraving = snap.engraving || '';
      if (engraveInput) engraveInput.value = state.engraving;
      state.intentionIdx = typeof snap.intentionIdx === 'number' ? snap.intentionIdx : -1;
      state.intention = state.intentionIdx >= 0 ? (config.intentions[state.intentionIdx] || null) : null;
      state.sizeIdx = typeof snap.sizeIdx === 'number' ? snap.sizeIdx : -1;
      state.size = state.sizeIdx >= 0 ? (config.wristSizes[state.sizeIdx] || null) : null;
      document.querySelectorAll('.diy-bracelet__intention').forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.getAttribute('data-idx'), 10) === state.intentionIdx);
      });
      var curEl = document.getElementById('diy-bracelet-current-intention');
      if (curEl) curEl.textContent = state.intention ? state.intention.title : '—';
      renderBadge();
      renderOptions();
      renderSizes();
      renderPreview();
      renderSummary();
      if (typeof renderIntentBanner === 'function') renderIntentBanner();
      syncUndoRedoBtns();
    } catch (e) {
      showStatus('Could not redo.', true);
    }
  }

  function findBeadByBase(base) {
    var mm = String(state.sizeMm || '8');
    var want = (base + '-' + mm + 'mm').toLowerCase();
    var hit = beadOptions.find(function (o) { return (o.handle || '').toLowerCase() === want; });
    if (hit) return hit;
    return beadOptions.find(function (o) {
      var h = (o.handle || '').toLowerCase();
      return h.indexOf(base.toLowerCase()) === 0 && h.indexOf(mm + 'mm') !== -1;
    });
  }

  function applyIntentionRecipe() {
    if (!state.intention) return;
    if (state._recipeAnimating) return;

    var items = buildRandomRecipeItems();
    if (!items.length) {
      showStatus('Could not build a set at ' + (state.sizeMm || '8') + 'mm. Try another size or add more stones.', true);
      return;
    }
    var extraCharms = buildRandomRecipeCharms();

    pushHistory();
    state.beads = [];
    state.charms = [];
    state.enterIdx = -1;
    state.flyFrom = null;
    renderOptions();
    renderPreview();
    renderSummary();

    function recipeFlyOrigin(img) {
      var btn = document.querySelector('.js-apply-recipe');
      if (btn) {
        var r = btn.getBoundingClientRect();
        return { x: r.left, y: r.top, w: Math.max(r.width, 48), h: Math.max(r.height, 36), image: img || '' };
      }
      if (previewBox) {
        var pr = previewBox.getBoundingClientRect();
        return { x: pr.left + pr.width / 2 - 24, y: pr.top + 12, w: 48, h: 48, image: img || '' };
      }
      return { x: window.innerWidth / 2 - 24, y: 120, w: 48, h: 48, image: img || '' };
    }

    state._recipeAnimating = true;
    showStatus('Shuffling a new ' + state.intention.title + ' design…', false);

    var idx = 0;
    function addNext() {
      if (idx >= items.length) {
        // 可选吊坠最后落下
        if (extraCharms && extraCharms.length) {
          state.charms = extraCharms.slice(0, config.maxCharms || 1);
        }
        state._recipeAnimating = false;
        state.enterIdx = -1;
        state.flyFrom = null;
        renderOptions();
        renderPreview();
        renderSummary();
        var msg = 'New ' + state.intention.title + ' mix · ' + items.length + ' beads';
        if (state.charms.length) msg += ' + charm';
        msg += '. Tap again for another random set.';
        showStatus(msg, false);
        return;
      }
      var bead = items[idx];
      state.beads.push(bead);
      state.enterIdx = state.beads.length - 1;
      state.flyFrom = recipeFlyOrigin(bead.image);
      idx += 1;
      renderOptions();
      renderPreview();
      renderSummary();
      setTimeout(addNext, 150);
    }
    setTimeout(addNext, 50);
  }

  function fillToMaxWrist() {
    if (!state.beads.length) {
      showStatus('Add at least one bead first, then Fill to max.', true);
      return;
    }
    pushHistory();
    var last = state.beads[state.beads.length - 1];
    var n = 0;
    while (n < 40) {
      var check = canAddBead(last);
      if (!check.ok) break;
      state.beads.push(last);
      n++;
    }
    renderOptions();
    renderPreview();
    renderSummary();
    showStatus(n ? ('Added ' + n + ' more to approach max wrist') : 'Already near max wrist size.', !n);
  }

  function renderIntentBanner() {
    var nodes = document.querySelectorAll('.diy-bracelet__intent-banner');
    if (!nodes.length) return;
    var html = '';
    if (state.intention) {
      html =
        '<span>Stones for <strong>' + escapeHtml(state.intention.title) + '</strong></span>' +
        '<button type="button" class="diy-intent-banner__btn js-apply-recipe">✦ Build a set</button>';
    }
    nodes.forEach(function (el) {
      if (!state.intention) {
        el.hidden = true;
        el.innerHTML = '';
      } else {
        el.hidden = false;
        el.innerHTML = html;
      }
    });
  }


  function showStoneInfo(item) {
    var meaning = stoneMeaning(item) || 'Intention stone';
    var mm = beadMmNumber(item);
    var msg = (item.title || 'Stone') + ' · ' + mm + 'mm · ' + meaning +
      '\nNatural crystal: each piece is unique in color and inclusion.';
    showStatus(msg.replace('\n', ' — '), false);
    // lightweight modal if present
    var panel = document.getElementById('diy-stone-info');
    if (panel) {
      panel.hidden = false;
      panel.innerHTML = '<strong>' + escapeHtml(item.title) + '</strong><p>' +
        escapeHtml(meaning) + ' · ' + mm + 'mm</p><p class="diy-stone-info__note">Natural stones vary — your bracelet will be one of a kind.</p>' +
        '<button type="button" class="diy-stone-info__close" id="diy-stone-info-close">Close</button>';
    }
  }

  function boostMainStone() {
    if (!state.beads.length) {
      showStatus('Add beads or use a suggested set first.', true);
      return;
    }
    pushHistory();
    // 找出出现最多的材质，再加 1～2 颗（受手围限制）
    var counts = {};
    state.beads.forEach(function (b) {
      var base = ((b.handle || '') + '').toLowerCase().replace(/-\d+mm$/i, '');
      counts[base] = (counts[base] || 0) + 1;
    });
    var main = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0];
    var item = findBeadByBase(main) || state.beads[0];
    var added = 0;
    for (var i = 0; i < 2; i++) {
      var check = canAddBead(item);
      if (!check.ok) break;
      state.beads.push(item);
      added++;
    }
    state.enterIdx = added ? state.beads.length - 1 : -1;
    renderOptions();
    renderPreview();
    renderSummary();
    showStatus(added ? ('Added more ' + (item.title || 'main stone')) : 'Wrist is full. Cannot add more.', !added);
  }

  function adjustBeadCount(delta) {
    if (delta < 0) {
      if (!state.beads.length) return;
      pushHistory();
      // 从末尾删，直到大约减 1～2 颗或低于 min 不再删到空
      var n = Math.min(2, state.beads.length);
      for (var i = 0; i < n; i++) {
        if (state.beads.length <= 1) break;
        state.beads.pop();
      }
      state.selectedBeadIdx = -1;
      renderOptions();
      renderPreview();
      renderSummary();
      showStatus('Removed some beads. Use Undo to restore.', false);
      return;
    }
    // delta > 0: 复制最后一颗往上加
    if (!state.beads.length) {
      showStatus('Add beads first.', true);
      return;
    }
    pushHistory();
    var last = state.beads[state.beads.length - 1];
    var added = 0;
    for (var j = 0; j < 2; j++) {
      var check = canAddBead(last);
      if (!check.ok) break;
      state.beads.push(last);
      added++;
    }
    renderOptions();
    renderPreview();
    renderSummary();
    showStatus(added ? ('Added ' + added + ' more beads') : 'Already near max wrist.', !added);
  }


  function renderBeadActions() {
    var bar = document.getElementById('diy-bead-actions');
    var label = document.getElementById('diy-bead-actions-label');
    if (!bar) return;
    var idx = state.selectedBeadIdx;
    if (idx < 0 || idx >= state.beads.length) {
      bar.hidden = true;
      state.replaceMode = false;
      return;
    }
    var b = state.beads[idx];
    bar.hidden = false;
    if (label) {
      label.textContent = (b && b.title) ? ('Selected: ' + b.title) : 'Bead selected';
    }
  }

  function removeSelectedBead() {
    var idx = state.selectedBeadIdx;
    if (idx < 0 || idx >= state.beads.length) return;
    pushHistory();
    state.beads.splice(idx, 1);
    state.selectedBeadIdx = -1;
    state.replaceMode = false;
    renderOptions();
    renderPreview();
    renderSummary();
    renderBeadActions();
    showStatus('Bead removed. Undo if needed.', false);
  }

  function cancelBeadSelection() {
    state.selectedBeadIdx = -1;
    state.replaceMode = false;
    renderOptions();
    renderPreview();
    renderBeadActions();
    showStatus('', false);
  }

  function armReplaceMode() {
    if (state.selectedBeadIdx < 0) {
      showStatus('Tap a bead on the ring first.', true);
      return;
    }
    state.replaceMode = true;
    renderOptions();
    renderBeadActions();
    showStatus('Now tap a stone in the list to replace the selected bead.', false);
    // mobile: jump to beads step
    if (typeof isMobileLab === 'function' && isMobileLab() && typeof goStep === 'function') {
      var steps = typeof availableSteps === 'function' ? availableSteps() : [];
      var bi = steps.indexOf('beads');
      if (bi >= 0) goStep(bi);
    }
  }

  function clearAll() {
    if (!state.beads.length && !state.charms.length && !state.engraving) return;
    pushHistory();
    state.beads = [];
    state.charms = [];
    state.engraving = '';
    if (engraveInput) engraveInput.value = '';
    renderOptions();
    renderPreview();
    renderSummary();
    showStatus('Cleared. You can Undo if that was a mistake.', false);
  }

  // 初始化完成前，goStep 不触发滚动（避免加载时抽屉自动滚一段）
  var stepScrollEnabled = false;
  setTimeout(function () { stepScrollEnabled = true; }, 1500);

  // 移动端工具条：低频按钮默认收起，点「More」展开
  var toolsMoreBtn = document.getElementById('diy-tools-more');
  if (toolsMoreBtn) {
    toolsMoreBtn.addEventListener('click', function () {
      var box = document.getElementById('diy-bracelet-tools');
      if (!box) return;
      var open = box.classList.toggle('is-expanded');
      toolsMoreBtn.textContent = open ? 'Less' : 'More';
    });
  }

  mountPlate();
  mountFitStatus();
  mountLongPress();
  mountShipBar();
  buildFilterRail();
  mountBeadSearch();


  // ---------- 左侧筛选竖栏（照搬 PebblePal）----------
  function buildFilterRail() {
    if (!isMobileLab()) return;
    var beadsGroup = document.querySelector('.diy-bracelet__builder-col > .diy-bracelet__group[data-diy-step="beads"]');
    if (!beadsGroup || beadsGroup.querySelector('.diy-filter-rail')) return;

    var rail = document.createElement('div');
    rail.className = 'diy-filter-rail';

    var intents = document.getElementById('diy-bracelet-intentions');
    if (intents) {
      var l1 = document.createElement('div');
      l1.className = 'diy-filter-rail__label';
      l1.textContent = 'Intention';
      rail.appendChild(l1);
      rail.appendChild(intents);   // 整体搬移：点击监听绑在容器上，安全
    }
    var mm = document.getElementById('diy-bracelet-mm-filters');
    if (mm) {
      var l2 = document.createElement('div');
      l2.className = 'diy-filter-rail__label';
      l2.textContent = 'Size';
      rail.appendChild(l2);
      rail.appendChild(mm);
    }
    beadsGroup.insertBefore(rail, beadsGroup.firstChild);

    // 搬空后的「意图」分组隐藏
    var ig = document.querySelector('.diy-bracelet__builder-col > .diy-bracelet__group[data-diy-step="intention"]');
    if (ig) ig.classList.add('is-rail-emptied');
  }

  // ---------- 珠子搜索框 ----------
  function mountBeadSearch() {
    if (!isMobileLab()) return;
    var beadsGroup = document.querySelector('.diy-bracelet__builder-col > .diy-bracelet__group[data-diy-step="beads"]');
    if (!beadsGroup || document.getElementById('diy-bead-search')) return;
    var wrap = document.createElement('div');
    wrap.className = 'diy-bead-search';
    wrap.innerHTML =
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
      '<circle cx="11" cy="11" r="7"/><path d="M20 20l-3.6-3.6"/></svg>' +
      '<input type="search" id="diy-bead-search" placeholder="Search by name, size or price" autocomplete="off" aria-label="Search beads by name, size or price">';
    var rail = beadsGroup.querySelector('.diy-filter-rail');
    if (rail) beadsGroup.insertBefore(wrap, rail); else beadsGroup.insertBefore(wrap, beadsGroup.firstChild);

    var input = document.getElementById('diy-bead-search');
    if (input) {
      input.addEventListener('input', function () {
        state.search = input.value.trim().toLowerCase();
        renderOptions();
      });
    }
  }

  // ---------- 免运费进度条（照搬 PebblePal）----------
  var FREE_SHIP_THRESHOLD = 75;
  var __cartSubtotal = 0;   // 购物车已有金额（初始化时读一次）
  function parseMoneyText(t) {
    var m = String(t == null ? '' : t).replace(/[^0-9.]/g, '');
    var n = parseFloat(m);
    return isFinite(n) ? n : 0;
  }
  function updateShipBar() {
    var el = document.getElementById('diy-ship-bar');
    if (!el) return;
    // 当前设计的总价（从清单总价元素读，避免重复实现计价逻辑）
    var design = totalEl ? parseMoneyText(totalEl.textContent) : 0;
    var subtotal = __cartSubtotal + design;
    var left = Math.max(0, FREE_SHIP_THRESHOLD - subtotal);
    var pct = Math.min(100, (subtotal / FREE_SHIP_THRESHOLD) * 100);
    var txt = el.querySelector('.diy-ship-bar__text');
    var fill = el.querySelector('.diy-ship-bar__fill');
    if (txt) {
      txt.innerHTML = left > 0
        ? '<strong>$' + left.toFixed(2) + '</strong> away from <strong>FREE shipping</strong>'
        : '<strong>You\u2019ve unlocked FREE U.S. shipping</strong>';
    }
    // 用 transform 而不是 width：过渡 width 会每帧触发 reflow（layout thrash）
    if (fill) fill.style.transform = 'scaleX(' + (pct / 100).toFixed(4) + ')';
  }
  function mountShipBar() {
    var col = document.querySelector('.diy-bracelet__preview-col');
    var metrics = document.getElementById('diy-lab-metrics');
    if (!col || !document.getElementById('diy-ship-bar')) {
      if (!col) return;
    }
    var host = metrics && metrics.parentNode ? metrics.parentNode : col;
    var el = document.createElement('div');
    el.id = 'diy-ship-bar';
    el.className = 'diy-ship-bar';
    el.innerHTML =
      '<div class="diy-ship-bar__text"></div>' +
      '<div class="diy-ship-bar__track"><i class="diy-ship-bar__fill"></i></div>';
    if (metrics && metrics.nextSibling) host.insertBefore(el, metrics.nextSibling);
    else host.appendChild(el);
    updateShipBar();
    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (c) { __cartSubtotal = (c.total_price || 0) / 100; updateShipBar(); })
      .catch(function () {});
  }

  var undoBtn = document.getElementById('diy-bracelet-undo');
  var clearBtn = document.getElementById('diy-bracelet-clear');
  if (undoBtn) undoBtn.addEventListener('click', undoLast);
  if (clearBtn) clearBtn.addEventListener('click', function () {
    if (!state.beads.length && !state.charms.length && !state.engraving) return;
    if (!window.confirm('Clear this bracelet design?')) return;
    clearAll();
  });
  var redoBtn = document.getElementById('diy-bracelet-redo');
  if (redoBtn) redoBtn.addEventListener('click', redoLast);
  var fillBtn = document.getElementById('diy-bracelet-fill');
  if (fillBtn) fillBtn.addEventListener('click', fillToMaxWrist);
  var boostBtn = document.getElementById('diy-bracelet-boost');
  if (boostBtn) boostBtn.addEventListener('click', boostMainStone);
  var fewerBtn = document.getElementById('diy-bracelet-fewer');
  if (fewerBtn) fewerBtn.addEventListener('click', function () { adjustBeadCount(-1); });
  var moreBtn = document.getElementById('diy-bracelet-more');
  if (moreBtn) moreBtn.addEventListener('click', function () { adjustBeadCount(1); });
  var actReplace = document.getElementById('diy-bead-act-replace');
  var actRemove = document.getElementById('diy-bead-act-remove');
  var actCancel = document.getElementById('diy-bead-act-cancel');
  if (actReplace) actReplace.addEventListener('click', armReplaceMode);
  if (actRemove) actRemove.addEventListener('click', removeSelectedBead);
  if (actCancel) actCancel.addEventListener('click', cancelBeadSelection);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'diy-stone-info-close') {
      var p = document.getElementById('diy-stone-info');
      if (p) { p.hidden = true; p.innerHTML = ''; }
    }
    if (e.target && e.target.id === 'diy-share-card-close') {
      var sp = document.getElementById('diy-share-card-panel');
      if (sp) sp.hidden = true;
    }
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.classList && t.classList.contains('js-apply-recipe') || (t.closest && t.closest('.js-apply-recipe'))) {
      e.preventDefault();
      applyIntentionRecipe();
      // mobile: jump to beads tab so user sees the filled ring + stones
      if (typeof isMobileLab === 'function' && isMobileLab() && typeof goStep === 'function') {
        var steps = typeof availableSteps === 'function' ? availableSteps() : [];
        var bi = steps.indexOf('beads');
        if (bi >= 0) goStep(bi);
      }
    }
  });


  var coach = document.getElementById('diy-coach');
  var coachDismiss = document.getElementById('diy-coach-dismiss');
  try {
    if (localStorage.getItem('diy_coach_dismissed_v1') === '1' && coach) coach.hidden = true;
  } catch (e) {}
  if (coachDismiss && coach) {
    coachDismiss.addEventListener('click', function () {
      coach.hidden = true;
      try { localStorage.setItem('diy_coach_dismissed_v1', '1'); } catch (e) {}
    });
  }

  var dockCtaBind = document.getElementById('diy-lab-dock-cta') || document.getElementById('diy-lab-dock-add');
  if (dockCtaBind) dockCtaBind.addEventListener('click', function () {
    // 尺寸不足时，这个按钮的作用是"带客户去加珠子"，而不是下单
    var mmDock = calcWristMm();
    var limDock = wristLimits();
    if ((state.beads.length || state.charms.length) && mmDock < limDock.min) {
      var target = document.getElementById('diy-bead-search') ||
                   document.querySelector('.diy-bracelet__beads, .diy-bracelet__options');
      if (target) {
        try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        catch (e) { target.scrollIntoView(); }
      }
      showStatus('Add about ' + (limDock.min - mmDock) + ' mm more stones to reach the ' + limDock.min + ' mm minimum.', false);
      return;
    }
    addToCart();
  });


  // ── 复核抽屉 ──────────────────────────────────────────────────────────
  var reviewCloseBtn = document.getElementById('diy-review-close');
  var reviewBackBtn = document.getElementById('diy-review-back');
  var reviewScrim = document.getElementById('diy-review-scrim');
  var reviewConfirmBtn = document.getElementById('diy-review-confirm');
  if (reviewCloseBtn) reviewCloseBtn.addEventListener('click', closeReview);
  if (reviewBackBtn) reviewBackBtn.addEventListener('click', closeReview);
  if (reviewScrim) reviewScrim.addEventListener('click', closeReview);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && reviewEl && !reviewEl.hidden) closeReview();
  });
  if (reviewConfirmBtn) reviewConfirmBtn.addEventListener('click', function () {
    closeReview();
    // 先过一遍手围下限的温和确认（与原来一致：点两次才放行）
    addToCart();
  });
  // addToCart 里一旦真要动手就先开准备弹窗
  var __origAddToCart = addToCart;

  if (beadsBox) beadsBox.addEventListener('click', handleOptionClick);
  if (charmsBox) charmsBox.addEventListener('click', handleOptionClick);
  if (accessoriesBox) accessoriesBox.addEventListener('click', handleOptionClick);
  /**
   * 键盘激活珠子 / 吊坠卡片。
   *
   * 为什么需要：卡片是 <div role="button" tabindex="0">，不是原生 <button>。
   * 浏览器只在原生按钮上把 Enter/Space 合成为 click —— div 不会。所以
   * 只监听 click 的结果是：Tab 能聚焦到珠子，但回车和空格毫无反应，
   * 整个主任务对键盘用户和读屏用户不可用（WCAG 2.1.1 失败）。
   * 这里复用 handleOptionClick，保证键盘和鼠标走完全同一条路径。
   */
  function handleOptionKeydown(e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    if (!e.target || !e.target.closest) return;
    var card = e.target.closest('.diy-bracelet__option');
    if (!card) return;
    e.preventDefault();          // 空格默认会滚动页面
    var type = card.getAttribute('data-type');
    var id = card.getAttribute('data-id');
    handleOptionClick(e);
    // 网格会被整体重绘（renderOptions 重建 innerHTML），被聚焦的卡片随之被销毁，
    // 焦点掉回 <body>。若不恢复，键盘用户每加一颗都要 Tab 一路找回来 ——
    // 加 18 颗就是 18 次。用 data-type + data-id 找回同一颗珠子的新卡片。
    // 若这次没加成功（例如已到上限），网格不会重绘，元素还在，focus() 是幂等的。
    if (type !== null && id !== null) {
      var again = document.querySelector(
        '.diy-bracelet__option[data-type="' + type + '"][data-id="' + id + '"]');
      if (again) again.focus();
    }
  }
  if (beadsBox) beadsBox.addEventListener('keydown', handleOptionKeydown);
  if (charmsBox) charmsBox.addEventListener('keydown', handleOptionKeydown);
  if (accessoriesBox) accessoriesBox.addEventListener('keydown', handleOptionKeydown);
  if (intentionsBox) intentionsBox.addEventListener('click', handleIntentionClick);
  if (sizesBox) sizesBox.addEventListener('click', handleSizeClick);
  previewBox.addEventListener('pointerdown', handlePreviewPointerDown);
  previewBox.addEventListener('pointermove', handlePreviewPointerMove);
  previewBox.addEventListener('pointerup', handlePreviewPointerUp);
  previewBox.addEventListener('pointercancel', handlePreviewPointerCancel);
  // 阻止拖拽时页面滚动
  previewBox.style.touchAction = 'none';
  summaryEl.addEventListener('click', handleSummaryClick);
  // 主按钮不再直接加购 —— 先开复核抽屉，客户看清价格和用料再确认
  addBtn.addEventListener('click', openReview);
  if (saveBtn) saveBtn.addEventListener('click', saveDesign);
  /* 珠子重排：显式按钮，键盘与触摸都可用 */
  function moveSelectedBead(delta) {
    var sel = state.selectedIndex;
    if (sel === null || sel === undefined || sel < 0) return;
    var to = sel + delta;
    if (to < 0 || to >= state.beads.length) return;
    var tmp = state.beads[sel];
    state.beads[sel] = state.beads[to];
    state.beads[to] = tmp;
    state.selectedIndex = to;
    renderPreview();
    renderSummary();
    syncLabMetrics();
    showStatus(delta < 0 ? 'Moved earlier in the strand.' : 'Moved later in the strand.', false);
  }
  var moveLeftBtn = document.getElementById('diy-bead-act-left');
  var moveRightBtn = document.getElementById('diy-bead-act-right');
  if (moveLeftBtn) moveLeftBtn.addEventListener('click', function (e) { e.stopPropagation(); moveSelectedBead(-1); });
  if (moveRightBtn) moveRightBtn.addEventListener('click', function (e) { e.stopPropagation(); moveSelectedBead(1); });


  /* ---- 手腕测量弹窗（借鉴 BeadDIY 的 5 步图文）---- */
  (function () {
    var box = document.getElementById('diy-measure');
    var openBtn = document.getElementById('diy-how-to-measure');
    var closeBtn = document.getElementById('diy-measure-close');
    if (!box) return;
    function open() {
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      box.hidden = true;
      document.body.style.overflow = '';
    }
    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
  })();

  /* ---- 尺寸筛选按钮上显示数量 ---- */
  function paintSizeCounts() {
    var box = document.getElementById('diy-bracelet-mm-filters');
    if (!box || !beadOptions.length) return;
    var counts = {};
    beadOptions.forEach(function (o) {
      var m = String(o.title || '').match(/(\d+)\s*mm/i);
      if (m) counts[m[1]] = (counts[m[1]] || 0) + 1;
    });
    [].forEach.call(box.querySelectorAll('.diy-bracelet__mm-btn'), function (btn) {
      var mm = btn.getAttribute('data-mm');
      if (btn.querySelector('.diy-mm-count')) return;
      var n = counts[mm] || 0;
      var sp = document.createElement('span');
      sp.className = 'diy-mm-count';
      sp.textContent = n;
      btn.appendChild(sp);
    });
  }

  /* ---- 设计备注：随订单一起提交 ---- */
  function mountDesignNote() {
    var ta = document.getElementById('diy-design-note');
    if (!ta) return;
    var form = document.getElementById('diy-bracelet-form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    if (form.querySelector('input[name="properties[Design notes]"]')) return;
    var h = document.createElement('input');
    h.type = 'hidden';
    h.name = 'properties[Design notes]';
    form.appendChild(h);
    function sync() { h.value = ta.value; }
    ta.addEventListener('input', sync);
    ta.addEventListener('change', sync);
    form.addEventListener('submit', sync, true);
    sync();
  }

  if (shareBtn) shareBtn.addEventListener('click', shareDesign);
  if (publishBtn) publishBtn.addEventListener('click', openPublishModal);
  if (pubCancel) pubCancel.addEventListener('click', closePublishModal);
  if (pubConfirm) pubConfirm.addEventListener('click', publishDesign);
  if (publishModal) publishModal.addEventListener('click', function (e) {
    if (e.target === publishModal) closePublishModal();
  });
  if (engraveInput) {
    engraveInput.addEventListener('input', function (e) {
      state.engraving = e.target.value.trim();
      renderPreview();
      renderSummary();
    });
  }




  // ---------- Stone LAB mobile studio (tabs + dock) ----------
  var STEPS = ['intention', 'beads', 'charms', 'details', 'review'];
  var stepIndex = 0;
  var labTabs = document.getElementById('diy-lab-tabs');
  var labDock = document.getElementById('diy-lab-dock');
  var labDockCta = document.getElementById('diy-lab-dock-cta');
  var labDockPrice = document.getElementById('diy-lab-dock-price');
  var labDockCount = document.getElementById('diy-lab-dock-count');
  var labPriceMetric = document.getElementById('diy-lab-price-metric');
  var labBeadMetric = document.getElementById('diy-lab-bead-metric');

  function availableSteps() {
    return STEPS.filter(function (s) {
      return !!document.querySelector('[data-diy-step="' + s + '"]');
    });
  }

  function isMobileLab() {
    return window.matchMedia('(max-width: 900px)').matches;
  }

  function syncLabMetrics() {
    var beadN = (state.beads && state.beads.length) || 0;
    var charmN = (state.charms && state.charms.length) || 0;
    var priceText = totalEl ? (totalEl.textContent || '—') : '—';
    if (labBeadMetric) labBeadMetric.textContent = String(beadN);
    if (labPriceMetric) labPriceMetric.textContent = priceText;
    if (labDockPrice) labDockPrice.textContent = priceText;
    if (labDockCount) {
      labDockCount.textContent = beadN + ' beads' + (charmN ? ' · ' + charmN + ' charms' : '');
    }
    if (labDockCta && addBtn) {
      labDockCta.disabled = !!addBtn.disabled;
    }
    if (typeof updateDockVisibility === 'function') updateDockVisibility();
    // 免邮进度条随设计金额实时更新
    if (typeof updateShipBar === 'function') updateShipBar();
    if (typeof renderFitStatus === 'function') renderFitStatus();
  }

  function goStep(i) {
    var steps = availableSteps();
    if (!steps.length) return;
    if (i < 0) i = 0;
    if (i > steps.length - 1) i = steps.length - 1;
    stepIndex = i;
    var current = steps[stepIndex];
    document.querySelectorAll('[data-diy-step]').forEach(function (el) {
      el.classList.toggle('is-step-active', el.getAttribute('data-diy-step') === current);
    });
    if (labTabs) {
      labTabs.querySelectorAll('[data-diy-goto]').forEach(function (btn) {
        var key = btn.getAttribute('data-diy-goto');
        btn.classList.toggle('is-active', key === current);
        btn.hidden = steps.indexOf(key) === -1;
      });
    }
    syncLabMetrics();
    if (typeof renderIntentBanner === 'function') renderIntentBanner();
    var prog = document.getElementById('diy-lab-progress-text');
    if (prog) {
      prog.textContent = 'Step ' + (stepIndex + 1) + ' of ' + steps.length;
    }
    // 移动端是一屏布局（所有分组常显），标签栏改为滚动锚点：
    // 点标签不再切换显示，而是把抽屉滚到对应分组。
    // 注意：初始化时 initMobileWizard() 也会调 goStep()，
    // 那时不应滚动，否则页面一加载抽屉就自己滚一段。
    if (isMobileLab() && stepScrollEnabled) {
      var scroller = document.querySelector('.diy-bracelet__builder-col');
      var targetEl = document.querySelector('[data-diy-step="' + current + '"]');
      if (scroller && targetEl) {
        var offset = targetEl.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - 52;
        scroller.scrollTo({ top: Math.max(0, offset), behavior: 'smooth' });
      }
    }
  }

  function initMobileWizard() {
    // keep name for existing call sites
    var on = isMobileLab();
    if (labTabs) labTabs.style.display = on ? '' : 'none';
    if (labDock) labDock.style.display = on ? '' : 'none';
    if (on) {
      if (!availableSteps().length) return;
      // 默认进入 Beads，降低跳出；意图用横滑 chip 仍可切换
      var steps = availableSteps();
      var beadsIdx = steps.indexOf('beads');
      if (stepIndex === 0 && beadsIdx >= 0 && state.beads.length > 0) {
        stepIndex = beadsIdx;
      }
      goStep(stepIndex);
    } else {
      document.querySelectorAll('[data-diy-step]').forEach(function (el) {
        el.classList.add('is-step-active');
      });
    }
    syncLabMetrics();
  }

  if (labTabs) {
    labTabs.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-diy-goto]');
      if (!btn) return;
      var steps = availableSteps();
      var idx = steps.indexOf(btn.getAttribute('data-diy-goto'));
      if (idx >= 0) goStep(idx);
    });
  }
  if (labDockCta) {
    labDockCta.addEventListener('click', function () {
      if (addBtn && !addBtn.disabled) addBtn.click();
    });
  }
  window.addEventListener('resize', function () { initMobileWizard(); });



  var autoSaveTimer = null;
  function scheduleAutoSave() {
    try {
      if (autoSaveTimer) clearTimeout(autoSaveTimer);
      autoSaveTimer = setTimeout(function () {
        try {
          if (state.beads.length || state.charms.length || state.engraving) {
            localStorage.setItem('diy_bracelet_design_v1', JSON.stringify(encodeDesign()));
          }
        } catch (e) {}
      }, 400);
    } catch (e) {}
  }

  // ---------- 初始化 ----------

  // ---------- 悬浮结算栏显隐（P2-5） ----------
  // 首页首屏原本就浮着 "0 beads / $0.00 / Add to cart"，容易困惑。
  // 仅当定制器进入视口或已选珠子时才显示。
  var dockInView = false;
  function updateDockVisibility() {
    if (!labDock) return;
    var hasItems = (state.beads && state.beads.length > 0) || (state.charms && state.charms.length > 0);
    var show = dockInView || hasItems;
    labDock.classList.toggle('is-visible', !!show);
  }
  try {
    if (typeof IntersectionObserver === 'function') {
      var diySectionEl = document.getElementById('diy-bracelet');
      if (diySectionEl) {
        document.documentElement.classList.add('js-dock-ready');
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { dockInView = en.isIntersecting; });
          updateDockVisibility();
        }, { rootMargin: '0px 0px -35% 0px', threshold: 0 }).observe(diySectionEl);
      }
    }
  } catch (dockErr) {
    document.documentElement.classList.remove('js-dock-ready');
  }

  function init() {
    if (!config.baseProductId) {
      showStatus('请先在 section 设置里选择「底座商品」。', true);
      return;
    }
    renderPreview();
    renderSummary();
    renderSizes();
    renderBadge();
    if (typeof renderIntentBanner === 'function') renderIntentBanner();
    if (typeof syncUndoRedoBtns === 'function') syncUndoRedoBtns();

    if (!config.beadsCollection && !config.charmsCollection) {
      showStatus('Please configure the beads collection in section settings.', true);
      return;
    }

    Promise.all([
      fetchCollection(config.beadsCollection).catch(function () { return []; }),
      fetchCollection(config.accessoriesCollection).catch(function () { return []; })
    ]).then(function (results) {
      beadOptions = results[0];
      charmOptions = [];              // 吊坠栏已移除
      accessoryOptions = results[1];  // 配饰库
      // 透明检测是异步的：先按「不透明」渲染，测出来是抠图再重画一次。
      // 这样首屏不用等 60 多张图解码。
      detectCutoutsFor(beadOptions.concat(accessoryOptions), function (changed) {
        if (changed) { renderPreview(); }
      });
      paintSizeCounts();
      mountDesignNote();
      renderOptions();
      renderPreview();
      renderSummary();
      restoreDesign();
      if (typeof scheduleAutoSave === 'function') scheduleAutoSave();   // 之前零调用点，刷新会丢设计
      initMobileWizard();
    });
    // also try immediately for static steps
    initMobileWizard();
  }

  // patch showStatus/renderSummary to refresh mobile total
  var _renderSummary = renderSummary;
  renderSummary = function () { _renderSummary(); if (typeof syncLabMetrics==='function') syncLabMetrics(); };

  init();
})();
